const VOLUNTEER_TECHNICAL_SUPPORT_CONSULTANT_FEEDBACK_FORM = process.env.VOLUNTEER_TECHNICAL_SUPPORT_CONSULTANT_FEEDBACK_FORM;
const ENCOUNTER_FORM = process.env.ENCOUNTER_FORM;
const TECHNICAL_SUPPORT_REQUESTOR_FEEDBACK_FORM = process.env.TECHNICAL_SUPPORT_REQUESTOR_FEEDBACK_FORM;
const VOLUNTEER_TECHNICAL_SUPPORT_CONSULTANT_PROFILE = process.env.VOLUNTEER_TECHNICAL_SUPPORT_CONSULTANT_PROFILE;
const TECHNICAL_SUPPORT_REQUESTOR_FORM = process.env.TECHNICAL_SUPPORT_REQUESTOR_FORM;
const ASSETS_CONTAINER_LINK = process.env.ASSETS_CONTAINER_LINK;
const SHOW_EQUIPMENT_TECHNICAL_SUPPORT_TIMINGS = Boolean(JSON.parse(process.env.SHOW_EQUIPMENT_TECHNICAL_SUPPORT_TIMINGS));
const DOCTOR_LIST_SIZE = Number(JSON.parse(process.env.DOCTOR_LIST_SIZE));
const MOBILE_DOCTOR_LIST_SIZE = Number(JSON.parse(process.env.MOBILE_DOCTOR_LIST_SIZE));
const INCREMENTAL_DOCTOR_LIST_SIZE = Number(JSON.parse(process.env.INCREMENTAL_DOCTOR_LIST_SIZE));
const NUTRITIONIST_LIST_SIZE = Number(JSON.parse(process.env.NUTRITIONIST_LIST_SIZE));
const MOBILE_NUTRITIONIST_LIST_SIZE = Number(JSON.parse(process.env.MOBILE_NUTRITIONIST_LIST_SIZE));
const INCREMENTAL_NUTRITIONIST_LIST_SIZE = Number(JSON.parse(process.env.INCREMENTAL_NUTRITIONIST_LIST_SIZE));
const FAQ_AND_SUPPORT = process.env.FAQ_AND_SUPPORT;
const VOLUNTEER_REGISTRATION_FORM = process.env.VOLUNTEER_REGISTRATION_FORM;
const FMC_COUNTDOWN_TIMER = Boolean(JSON.parse(process.env.FMC_COUNTDOWN_TIMER));
const HOMPAGE_BASE_UK_URL = process.env.HOMPAGE_BASE_UK_URL;

const URLS = [
    {
        // "Select a country"
        API_BASE_URL: process.env.API_BASE_URL,
        BLOGS_BASE_URL: process.env.BLOGS_BASE_URL,
        HOMPAGE_BASE_URL: process.env.HOMPAGE_BASE_URL,
        PORTAL_BASE_URL: process.env.PORTAL_BASE_URL,
    },
    {
        // USA
        API_BASE_URL: process.env.API_BASE_URL,
        BLOGS_BASE_URL: process.env.BLOGS_BASE_URL,
        HOMPAGE_BASE_URL: process.env.HOMPAGE_BASE_URL,
        PORTAL_BASE_URL: process.env.PORTAL_BASE_URL,
    },
    {
        // India
        API_BASE_URL: process.env.API_BASE_URL,
        BLOGS_BASE_URL: process.env.BLOGS_BASE_URL,
        HOMPAGE_BASE_URL: process.env.HOMPAGE_BASE_URL,
        PORTAL_BASE_URL: process.env.PORTAL_BASE_URL,
    },
    {
        // UK
        API_BASE_URL: process.env.API_BASE_URL,
        BLOGS_BASE_URL: process.env.BLOGS_BASE_URL,
        HOMPAGE_BASE_URL: process.env.HOMPAGE_BASE_URL,
        PORTAL_BASE_URL: process.env.PORTAL_BASE_URL,
    },
    {
        // Other
        API_BASE_URL: process.env.API_BASE_URL,
        BLOGS_BASE_URL: process.env.BLOGS_BASE_URL,
        HOMPAGE_BASE_URL: process.env.HOMPAGE_BASE_URL,
        PORTAL_BASE_URL: process.env.PORTAL_BASE_URL,
    },
];

var COUNTRY_DATA_GLOBAL_LIST = [];
var PRICING_DATA_GLOBAL_LIST = [];
var DEFAULT_DOCTOR_LIST_SIZE = DOCTOR_LIST_SIZE;
var CURRENT_DOCTOR_LIST_SIZE = DOCTOR_LIST_SIZE;
var DEFAULT_NUTRITIONIST_LIST_SIZE = NUTRITIONIST_LIST_SIZE;
var CURRENT_NUTRITIONIST_LIST_SIZE = NUTRITIONIST_LIST_SIZE;
var CURRENT_SELECTED_MAIN_COUNTRY_INDEX = 0;  // "Select a country"
var MAIN_COUNTRY_DROPDOWN_LIST = [
    {
        "value": 0,
        "label": "Select a country",
        "disabled": true,
        "raw_price": "",
        "currency_type": "",
        "final_value": "",
        "src": "./assets/images/home/flags/global_eglobaldoctors.png",
        "is_set_dom": false,
        "pricing_index": null
    },
    {
        "value": 1,
        "label": "USA",
        "disabled": false,
        "raw_price": "99",
        "discount": "",
        "currency_type": "USD",
        "final_value": "",
        "src": "./assets/images/home/flags/USA_Flag_eglobaldoctors.png",
        "is_set_dom": true,
        "pricing_index": "USA"
    },
    {
        "value": 2,
        "label": "India",
        "disabled": false,
        "raw_price": "199",
        "discount": "(60% OFF)",
        "currency_type": "INR",
        "final_value": "",
        "src": "./assets/images/home/flags/India_Flag_eglobaldoctors.png",
        "is_set_dom": true,
        "pricing_index": "India"
    },
    // {
    //     "value": 3,
    //     "label": "UK",
    //     "disabled": false,
    //     "raw_price": "75",
    //     "discount": "",
    //     "currency_type": "GBP",
    //     "final_value": "",
    //     "src": "./assets/images/home/flags/UK_Flag_eglobaldoctors.png",
    //     "is_set_dom": true,
    //     "pricing_index": "UK"
    // },
    {
        "value": 3,
        "label": "Other",
        "disabled": false,
        "raw_price": "99",
        "discount": "",
        "currency_type": "USD",
        "final_value": "",
        "src": "./assets/images/home/flags/globe_eglobaldoctors.png",
        "is_set_dom": true,
        "pricing_index": "Other"
    },
]

MAIN_COUNTRY_DROPDOWN_LIST.map((ele) => {
    if (Boolean(ele.raw_price) && Boolean(ele.currency_type)) {
        ele.final_value = getRenderedAmount(ele.raw_price, ele.currency_type);
        ele.final_value = ele.final_value.split(".")[0] + " " + ele.discount;
    }

});

function getDietValues() {
    var currentCountryLocalStorage = localStorage.getItem("Country_Dropdown_New");
    var country_id = (currentCountryLocalStorage === "India") ? 101 : 233;
    var currency_symbol = (currentCountryLocalStorage === "India") ? "₹" : "$";
    var strikeamount_1 = (currentCountryLocalStorage === "India") ? "3000" : "240";
    var strikeamount_2 = (currentCountryLocalStorage === "India") ? "6000" : "332";
    var strikeamount_3 = (currentCountryLocalStorage === "India") ? "9000" : "388";

    $.ajax({
        type: "POST",
        url: `${URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL}graphql`,
        contentType: "application/json",
        data: JSON.stringify({
            query: `
                query {
                    findPriorityTypes(
                      filter: {
                        consultation_type_id: { _eq: 5 }
                        is_enabled: { _eq: true }
                        country_id: { _eq: ${country_id} }
                        amount: { _gt: 0 }
                      }
                      order: { id: ASC }
                    ) {
                      id
                      transaction_type
                      consultation_name
                      is_enabled
                      amount
                      country_id
                      consultation_type_id
                      description,
                      number_of_consultations
                    }
                  }
            `
        }),
        success: function (response) {
            var result = response.data;

            if (result && result.findPriorityTypes && result.findPriorityTypes.length >= 3) {
                var findPriorityTypes = result.findPriorityTypes;

                var amount_1 = findPriorityTypes[0].amount;
                var amount_2 = findPriorityTypes[1].amount;
                var amount_3 = findPriorityTypes[2].amount;
                var no_of_consultations_1 = findPriorityTypes[0].number_of_consultations;
                var no_of_consultations_2 = findPriorityTypes[1].number_of_consultations;
                var no_of_consultations_3 = findPriorityTypes[2].number_of_consultations;
                var diet_plan_name1 = findPriorityTypes[0].consultation_name;
                var diet_plan_name2 = findPriorityTypes[1].consultation_name;
                var diet_plan_name3 = findPriorityTypes[2].consultation_name;


                document.getElementById('primary1').textContent = no_of_consultations_1;
                document.getElementById('primary2').textContent = no_of_consultations_2;
                document.getElementById('primary3').textContent = no_of_consultations_3;

                document.getElementById('price-basic').textContent = currency_symbol + amount_1;
                document.getElementById('price-wellness').textContent = currency_symbol + amount_2;
                document.getElementById('price-pro').textContent = currency_symbol + amount_3;

                document.getElementById('3mon-price-strike').textContent = currency_symbol + strikeamount_1;
                document.getElementById('6mon-price-strike').textContent = currency_symbol + strikeamount_2;
                document.getElementById('12mon-price-strike').textContent = currency_symbol + strikeamount_3;

                document.getElementById('wellness1').textContent = diet_plan_name1;
                document.getElementById('wellness2').textContent = diet_plan_name2;
                document.getElementById('wellness3').textContent = diet_plan_name3;

                var basicOldUs = document.getElementById("basicOldUs")
                var basicNewUs = document.getElementById("basicNewUs")
                var basicPlusOldUs = document.getElementById("basicPlusOldUs")
                var basicPlusNewUs = document.getElementById("basicPlusNewUs")
                var proOldUs = document.getElementById("proOldUs")
                var proNewUs = document.getElementById("proNewUs")

                if (basicOldUs) basicOldUs.innerHTML = currency_symbol + strikeamount_1;
                if (basicNewUs) basicNewUs.innerHTML = currency_symbol + amount_1;
                if (basicPlusOldUs) basicPlusOldUs.innerHTML = currency_symbol + strikeamount_2;
                if (basicPlusNewUs) basicPlusNewUs.innerHTML = currency_symbol + amount_2;
                if (proOldUs) proOldUs.innerHTML = currency_symbol + strikeamount_3;
                if (proNewUs) proNewUs.innerHTML = currency_symbol + amount_3;

            } else {
                console.error('Invalid response or insufficient data returned.');
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.error('There was an error fetching the data from the API:', errorThrown);
        }
    });

}

function setDOMCountry() {
    var s = document.getElementById("landingprice");
    var s1 = document.getElementById("landingprice1");
    var testData = !!document.getElementById("landingprice") && !!document.getElementById("landingprice1");
    testData = !!document.getElementById("landingprice1");
    testData = !!document.getElementById("landingprice");
    let country = MAIN_COUNTRY_DROPDOWN_LIST.filter((ele) => { return ele.value == CURRENT_SELECTED_MAIN_COUNTRY_INDEX })[0]
    $("#landingprice-div").hide()
    $("#landingprice1-div").hide()
    $("#landingprice-mob-div").hide()
    $("#landingprice1-mob-div").hide()
    if (country.is_set_dom) {
        if (testData) {
            s.textContent = country.final_value;
            s1.textContent = country.final_value;
            document.getElementById("img-flag-nav").src = country.src;
            document.getElementById("img-flag-nav1").src = country.src;
        }
        $("#landingprice-div").show()
        $("#landingprice-mob-div").show()
    }
    else {
        $("#landingprice1-div").show()
        $("#landingprice1-mob-div").show()
    }
}

//childElementCount
function setMainCountryDropdown(ele_id) {
    var parent_element = document.getElementById(ele_id);
    if (parent_element.childElementCount == 0) {
        for (let country of MAIN_COUNTRY_DROPDOWN_LIST) {
            var option_childElement = document.createElement('option');
            option_childElement.setAttribute("value", country.value);
            if (country.disabled)
                option_childElement.setAttribute("disabled", true);
            option_childElement.textContent = country.label;
            parent_element.appendChild(option_childElement);
        }
    }



    var currentCountryLocalStorage = localStorage.getItem("Country_Dropdown_New");
    if (Boolean(currentCountryLocalStorage)) {
        let data = MAIN_COUNTRY_DROPDOWN_LIST.filter((ele) => {
            return ele.label == currentCountryLocalStorage;
        })[0];
        if (data)
            CURRENT_SELECTED_MAIN_COUNTRY_INDEX = data.value;
    }

    setDOMCountry();
    parent_element.value = CURRENT_SELECTED_MAIN_COUNTRY_INDEX;

}


function onMainCountryDropdownChange(id_value) {
    // Country Change Dropdown On The Top Above the nav Bar    
    CURRENT_SELECTED_MAIN_COUNTRY_INDEX = document.getElementById(id_value).value;
    let dropdown_ids = ['main-country-dropdown', 'main-country-dropdown1'];
    dropdown_ids.forEach((ele) => {
        document.getElementById(ele).value = CURRENT_SELECTED_MAIN_COUNTRY_INDEX;
    });

    var thursdayOfferings = document.getElementById("thursday-offerings");
    var selectedCountryLabel = localStorage.getItem("Country_Dropdown");
    var phoneByCountry = document.getElementById('phone-by-country');
    var landingtravellingprice = document.getElementById('landingpageprice-usa');
    // if (MAIN_COUNTRY_DROPDOWN_LIST[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].label == "UK") {
    //     window.location.href = HOMPAGE_BASE_UK_URL;
    // }
    // else {
    localStorage.setItem("Country_Dropdown", MAIN_COUNTRY_DROPDOWN_LIST[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].label);
    setDOMCountry();
    // }
    if (MAIN_COUNTRY_DROPDOWN_LIST[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].label == "India") {
        thursdayOfferings.style.display = 'block';
        phoneByCountry.textContent = "+91 207-119-0009";
        phoneByCountry.setAttribute('data-href', 'tel:+91 207-119-0009');
        landingtravellingprice.textContent = "₹10000";

    } else {
        thursdayOfferings.style.display = 'none';
        phoneByCountry.textContent = " +1 213-406-7898";
        phoneByCountry.setAttribute('data-href', 'tel:+1 213-406-7898');
        landingtravellingprice.textContent = "$99"
    }

    // window.location.reload();
    window.location.reload();
}

//  added by sagar :
function onMainCountryDropdownChange1(id_value) {
    // Country Change Dropdown On The Top Above the nav Bar    
    CURRENT_SELECTED_MAIN_COUNTRY_INDEX = document.getElementById(id_value).value;
    let dropdown_ids = ['main-country-dropdown', 'main-country-dropdown-1'];
    dropdown_ids.forEach((ele) => {
        document.getElementById(ele).value = CURRENT_SELECTED_MAIN_COUNTRY_INDEX;
    });
    var thursdayOfferings = document.getElementById("thursday-offerings");
    var landingtravellingprice = document.getElementById('landingpageprice-usa');
    // if (MAIN_COUNTRY_DROPDOWN_LIST[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].label == "UK") {
    //     window.location.href = HOMPAGE_BASE_UK_URL;
    // }
    // else {
    localStorage.setItem("Country_Dropdown_New", MAIN_COUNTRY_DROPDOWN_LIST[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].label);
    setDOMCountry();
    // }
    if (MAIN_COUNTRY_DROPDOWN_LIST[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].label == "India") {
        thursdayOfferings.style.display = 'block';
        landingtravellingprice.textContent = "₹10000";
    } else {
        thursdayOfferings.style.display = 'none';
        landingtravellingprice.textContent = "$99";
    }
    // window.location.reload();
    checkcountry()
}

function checkpackagescountry() {
    if (MAIN_COUNTRY_DROPDOWN_LIST[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].label == "India") {
        getIndianPackageData();

    } else {
        getPackageData();
    }
}
function goToID(element_id) {
    $(document).ready(function () {
        // var current_url = window.location.href;
        // let current_hash = window.location.hash;
        if (Boolean(element_id)) {
            // window.location.hash = current_hash;
            // scrollToId(current_hash.slice(1));
            // let current_hash_id = current_hash.slice(1);
            let current_hash_id = element_id;
            let offsetTop_element = document.getElementById(current_hash_id).offsetTop;
            let offsetTop_navbar = document.getElementById("navbar-section").offsetHeight;
            let offsetTop_extra = 50;
            window.scrollTo(0, offsetTop_element - offsetTop_navbar - offsetTop_extra);
            // window.scrollTo(0, offsetTop_element);
        }
    });
}



function main_countDown_timer() {

    if (FMC_COUNTDOWN_TIMER) {
        var moment = require('moment-timezone');
        //const meeting_date = ('2021-11-14 19:30:00')
        const week_no = !moment.tz('Asia/Kolkata').weekday() ? 0 : 7;
        let meeting_date = moment.tz('Asia/Kolkata').weekday(week_no).set('hours', 18).set('minutes', 30).set('seconds', 0);
        let meeting_end = moment.tz('Asia/Kolkata').weekday(week_no).set('hours', 20).set('minutes', 30).set('seconds', 0);
        let b = moment(new Date()).tz('Asia/Kolkata')
        let should_display_timer = true;
        let has_meeting_started = false;
        if (moment(b).isAfter(meeting_end)) {
            document.getElementById("timer-outer").display = 'none';
            document.getElementById("timer-outer").style = 'none';
            return;
        }
        else if (moment(b).isAfter(meeting_date)) {
            should_display_timer = true;
            has_meeting_started = true;
        }
        let ms = (moment(meeting_date).diff(b, 'milliseconds'));
        if (moment(meeting_date).diff(b, 'hours') < 48) {
            setInterval(function () {
                var distance = ms;
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);
                // Display the result in the element with id="demo"
                ms -= 1000;
                if (distance < 0) {
                    clearInterval(x);
                    document.getElementById("democount").innerHTML = "Free Counseling Started";
                }
                else {
                    document.getElementById("democount").innerHTML = "Free Counseling Starts in " + hours + "h "
                        + minutes + "m " + seconds + "s ";
                }
            }, 1000);
        }
        else {
            document.getElementById("timer-outer").style.display = "none";
        }
    }
    else if (!FMC_COUNTDOWN_TIMER) {
        document.getElementById("timer-outer").style.display = "none";
    }
}


function locationHashChanged() {
    var current_hash = window.location.hash;
    if (current_hash) {
        scrollToId(current_hash.slice(1));
    }
}


function getIndianPackageData() {
    $.ajax({
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/package/list",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {

                    document.getElementById('3mon').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[0].expiry;
                    document.getElementById('6mon').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[1].expiry;
                    document.getElementById('12mon').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[2].expiry;
                    document.getElementById('wellness-b').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[0].package_name;
                    document.getElementById('wellness').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[1].package_name;
                    document.getElementById('wellness-pro').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[2].package_name;
                    document.getElementById('3mon-price').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[0].expiry;
                    document.getElementById('6mon-price').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[1].expiry;
                    document.getElementById('12mon-price').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[2].expiry;
                    document.getElementById('diet1').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[0].description[1];
                    document.getElementById('diet2').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[1].description[1];
                    document.getElementById('diet3').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[2].description[1];
                    document.getElementById('primary1').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[0].description[0];
                    document.getElementById('primary2').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[1].description[0];
                    document.getElementById('primary3').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[2].description[0];
                    document.getElementById('price-basic').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[0].amount;
                    document.getElementById('price-wellness').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[1].amount;
                    document.getElementById('price-pro').textContent = result.data.packages_groups.INDIA_WELLNESS_PACKAGES_INR[2].amount;

                    var parentElement = document.getElementById('packages-india-data-div');
                    var div_parentElement = document.createElement('div');
                    div_parentElement.className = "card-deck mt-5 p-lg-4";
                    for (let package of result.data.packages_groups.USA_TRAVELLING_PACKAGES_INR) {
                        var div1_childElement = document.createElement('div');
                        div1_childElement.className = "card packages-card mb-5";
                        div1_childElement.style.backgroundColor = package.color_code;
                        var div2_childElement = document.createElement('div');
                        div2_childElement.className = "card-body";
                        var div3_childElement = document.createElement('div');
                        div3_childElement.className = "row";
                        var div4_childElement = document.createElement('div');
                        div4_childElement.className = "col-4";
                        var img1_childElement = document.createElement('img');
                        img1_childElement.setAttribute("loading", "lazy");
                        img1_childElement.className = "lazyload";
                        img1_childElement.setAttribute("data-src", DOMPurify.sanitize(package.image_web));
                        img1_childElement.setAttribute("alt", DOMPurify.sanitize(package.package_name));
                        var div5_childElement = document.createElement('div');
                        div5_childElement.className = "col-4";
                        var div6_childElement = document.createElement('div');
                        div6_childElement.className = "col-4";
                        var img2_childElement = document.createElement('img');
                        img2_childElement.setAttribute("loading", "lazy");
                        img2_childElement.className = "lazyload pkgpricingimg";
                        img2_childElement.setAttribute("data-src", DOMPurify.sanitize(package.price_image));
                        img2_childElement.setAttribute("alt", DOMPurify.sanitize(package.package_name));
                        var h5_childElement = document.createElement('h5');
                        h5_childElement.className = "card-title font-weight-bolder heading2";
                        h5_childElement.textContent = package.package_name;

                        var p_childElement = document.createElement('p');
                        p_childElement.className = "card-text";
                        var ul_childElement = document.createElement('ul');
                        ul_childElement.className = "heading4";

                        var div7_childElement = document.createElement('div');
                        div7_childElement.className = "text-center";
                        var button_childElement = document.createElement("button");
                        button_childElement.setAttribute("type", "button");
                        button_childElement.setAttribute("role", "button");
                        button_childElement.setAttribute("onclick", "openWebsiteLinks('PORTAL_BASE_URL','user/login/patient','_blank')");
                        button_childElement.className = "btn btn-primary pkgbtn";
                        button_childElement.textContent = "Buy Now";

                        div4_childElement.appendChild(img1_childElement);
                        div6_childElement.appendChild(img2_childElement);
                        div3_childElement.appendChild(div4_childElement);
                        div3_childElement.appendChild(div5_childElement);
                        div3_childElement.appendChild(div6_childElement);
                        for (let desc of package.description) {
                            var li_childElement = document.createElement('li');
                            li_childElement.className = "card-li-txt";
                            li_childElement.textContent = desc;
                            ul_childElement.appendChild(li_childElement);
                        }
                        div7_childElement.appendChild(button_childElement);

                        div2_childElement.appendChild(div3_childElement);
                        div2_childElement.appendChild(h5_childElement);
                        div2_childElement.appendChild(p_childElement);
                        div2_childElement.appendChild(ul_childElement);
                        div2_childElement.appendChild(div7_childElement);

                        div1_childElement.appendChild(div2_childElement)

                        // parentElement.appendChild(div1_childElement);
                        div_parentElement.appendChild(div1_childElement);

                    }
                    parentElement.appendChild(div_parentElement);


                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}




function getPackageData() {
    $.ajax({
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/package/list",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {

                    var parentElement = document.getElementById('packages-data-div');
                    var div_parentElement = document.createElement('div');
                    div_parentElement.className = "card-deck mt-5 p-lg-4";
                    for (let package of result.data.packages_groups.USA_TRAVELLING_PACKAGES_USD) {
                        var div1_childElement = document.createElement('div');
                        div1_childElement.className = "card packages-card mb-5";
                        div1_childElement.style.backgroundColor = package.color_code;
                        var div2_childElement = document.createElement('div');
                        div2_childElement.className = "card-body";
                        var div3_childElement = document.createElement('div');
                        div3_childElement.className = "row";
                        var div4_childElement = document.createElement('div');
                        div4_childElement.className = "col-4";
                        var img1_childElement = document.createElement('img');
                        img1_childElement.setAttribute("loading", "lazy");
                        img1_childElement.className = "lazyload";
                        img1_childElement.setAttribute("data-src", DOMPurify.sanitize(package.image_web));
                        img1_childElement.setAttribute("alt", DOMPurify.sanitize(package.package_name));
                        var div5_childElement = document.createElement('div');
                        div5_childElement.className = "col-4";
                        var div6_childElement = document.createElement('div');
                        div6_childElement.className = "col-4";
                        var img2_childElement = document.createElement('img');
                        img2_childElement.setAttribute("loading", "lazy");
                        img2_childElement.className = "lazyload pkgpricingimg";
                        img2_childElement.setAttribute("data-src", DOMPurify.sanitize(package.price_image));
                        img2_childElement.setAttribute("alt", DOMPurify.sanitize(package.package_name));
                        var h5_childElement = document.createElement('h5');
                        h5_childElement.className = "card-title font-weight-bolder heading2";
                        h5_childElement.textContent = package.package_name;

                        var p_childElement = document.createElement('p');
                        p_childElement.className = "card-text";
                        var ul_childElement = document.createElement('ul');
                        ul_childElement.className = "heading4";

                        var div7_childElement = document.createElement('div');
                        div7_childElement.className = "text-center";
                        var button_childElement = document.createElement("button");
                        button_childElement.setAttribute("type", "button");
                        button_childElement.setAttribute("role", "button");
                        button_childElement.setAttribute("onclick", "openWebsiteLinks('PORTAL_BASE_URL','user/login/patient','_blank')");
                        button_childElement.className = "btn btn-primary pkgbtn";
                        button_childElement.textContent = "Buy Now";

                        div4_childElement.appendChild(img1_childElement);
                        div6_childElement.appendChild(img2_childElement);
                        div3_childElement.appendChild(div4_childElement);
                        div3_childElement.appendChild(div5_childElement);
                        div3_childElement.appendChild(div6_childElement);
                        for (let desc of package.description) {
                            var li_childElement = document.createElement('li');
                            li_childElement.className = "card-li-txt";
                            li_childElement.textContent = desc;
                            ul_childElement.appendChild(li_childElement);
                        }
                        div7_childElement.appendChild(button_childElement);

                        div2_childElement.appendChild(div3_childElement);
                        div2_childElement.appendChild(h5_childElement);
                        div2_childElement.appendChild(p_childElement);
                        div2_childElement.appendChild(ul_childElement);
                        div2_childElement.appendChild(div7_childElement);

                        div1_childElement.appendChild(div2_childElement)

                        // parentElement.appendChild(div1_childElement);
                        div_parentElement.appendChild(div1_childElement);

                    }
                    parentElement.appendChild(div_parentElement);


                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}


function setGlobalPricingDataValues() {
    $.ajax({
        async: false,
        type: "GET",
        url: "./assets/data/pricingData.json",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {

                    PRICING_DATA_GLOBAL_LIST = result.data.countries.slice();

                    var countries_list = [];
                    for (let i = 0; i < PRICING_DATA_GLOBAL_LIST.length; i++) {
                        countries_list.push(PRICING_DATA_GLOBAL_LIST[i].country);
                    }
                    COUNTRY_DATA_GLOBAL_LIST = countries_list.slice();
                }
                else if (!Boolean(result.success)) {
                    //error handling
                }
            }

        })
        .fail(function (jqXHR, textStatus, errorThrown) {


        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}

function createBackToTopButton() {
    var parent_element = document.getElementById('top-to-button-section');

    if (Boolean(parent_element)) {
        var button_childElement = document.createElement("button");
        var i_childElement = document.createElement("i");
        i_childElement.className = "fa fa-arrow-up font-size-xx-large";
        // i_childElement.innerHTML = "&#8593;";
        button_childElement.setAttribute("type", "button");
        button_childElement.setAttribute("role", "button");
        button_childElement.setAttribute("id", "go-top-button");
        button_childElement.setAttribute("onclick", "goToTop();");
        button_childElement.className = "btn btn-default btn-primary go-to-top-button p-4";
        button_childElement.appendChild(i_childElement);
        // button_childElement.textContent = "Back To Top";

        parent_element.appendChild(button_childElement);

    }

}


function onScrollEvent() {
    var mybutton = document.getElementById("go-top-button");
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    } else {
        mybutton.style.display = "none";
    }
}

function include_gototopbutton() {
    createBackToTopButton();
}

function goToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}

function toTitleCase(data) {
    var final_string = data[0].toUpperCase() + data.substring(1);
    return final_string;
}

function init_testimonial_carousel() {
    // $(document).ready(function () {
    var owl = $('.testimonial-owl-carousel');
    owl.owlCarousel({
        center: true,
        loop: true,
        dots: false,
        // margin: 10,
        nav: true,
        navText: ['<img src="./assets/images/home/Left_Arrow.png" class="testimonialsarrowleft" alt="testimonialsarrow">', '<img src="./assets/images/home/Right_Arrow.png" class="testimonialsarrowright" alt="testimonialsarrow">'],
        responsive: {
            0: {
                items: 1,
                autoWidth: true,
                margin: 15
            },
            600: {
                items: 1
            },
            1000: {
                items: 3
            }
        },
        slideBy: 1,
        autoplay: true,
        lazyLoad: true,
    });
    // owl.on('mousewheel', '.owl-stage', function (e) {
    //     if (e.deltaY > 0) {
    //         owl.trigger('next.owl');
    //     } else {
    //         owl.trigger('prev.owl');
    //     }
    //     e.preventDefault();
    // });
    // });
}

function init_featured_carousel() {
    // $(document).ready(function () {
    var owl = $('.featured-owl-carousel');
    owl.owlCarousel({
        center: true,
        loop: true,
        dots: false,
        margin: 10,
        // nav: true,
        // navText: ['<i class="fa fa-angle-left ml-sm-3" aria-hidden="true"></i>', '<i class="fa fa-angle-right mr-sm-3" aria-hidden="true"></i>'],
        responsive: {
            0: {
                items: 2
            },
            600: {
                items: 3
            },
            1000: {
                items: 5
            }
        },
        // slideBy: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        lazyLoad: true,
    });
    // owl.on('mousewheel', '.owl-stage', function (e) {
    //     if (e.deltaY > 0) {
    //         owl.trigger('next.owl');
    //     } else {
    //         owl.trigger('prev.owl');
    //     }
    //     e.preventDefault();
    // });
    // });
}

function init_specialty_carousel() {
    // $(document).ready(function () {
    var owl = $('.specialty-owl-carousel');
    owl.owlCarousel({
        center: true,
        loop: true,
        dots: false,
        // margin: 10,
        nav: true,
        navText: ['<img src="./assets/images/home/left_round_arrow.png" class="roundaarowprev"  alt="testimonialsarrow">', '<img src="./assets/images/home/right_round_arrow.png" class="roundaarownext" alt="testimonialsarrow">'],
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 5
            }
        },
        slideBy: 1,
        autoplay: true,
        lazyLoad: true,
    });
    // owl.on('mousewheel', '.owl-stage', function (e) {
    //     if (e.deltaY > 0) {
    //         owl.trigger('next.owl');
    //     } else {
    //         owl.trigger('prev.owl');
    //     }
    //     e.preventDefault();
    // });
    // });
}




function containerimages_carousel() {
    var owl = $('.containers-owl-carousel');
    owl.owlCarousel({
        center: true,
        loop: true,
        dots: false,
        nav: true,
        navText: ['<div class="roundaarowprev"><img src="./assets/images/home/left_round_arrow.png" alt="testimonialsarrow"></div>', '<div class="roundaarownext"><img src="./assets/images/home/right_round_arrow.png" alt="testimonialsarrow"></div>'],
        // margin: 10,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 5
            }
        },
        slideBy: 1,
        autoplay: true,
        lazyLoad: true,
    });
}


function init_our_partners_carousel() {
    // $(document).ready(function () {
    var owl = $('.our-partners-owl-carousel');
    owl.owlCarousel({
        center: true,
        loop: true,
        dots: false,
        margin: 10,
        // margin: 10,
        // nav: true,
        // navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
        responsive: {
            0: {
                items: 2
            },
            600: {
                items: 3
            },
            1000: {
                items: 5
            }
        },
        slideBy: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        lazyLoad: true,
    });
    // owl.on('mousewheel', '.owl-stage', function (e) {
    //     if (e.deltaY > 0) {
    //         owl.trigger('next.owl');
    //     } else {
    //         owl.trigger('prev.owl');
    //     }
    //     e.preventDefault();
    // });
    // });
}

function getFeaturedIn() {
    $.ajax({
        type: "GET",
        url: "./assets/data/featured_in.json",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('featured-in-data-div');
                        for (let featuredItem of result.data) {
                            // <div> 
                            //     <a href="{{featured.link}}" target="_self">
                            //         <img class="featured-in-image" src="{{featured.imgsrc}}" alt="{{featured.imgalt}}">
                            //     </a>
                            // </div>
                            var div_childElement = document.createElement('div');
                            div_childElement.className = "featured-in-item";
                            var a_childElement = document.createElement('a');
                            a_childElement.setAttribute("href", DOMPurify.sanitize(featuredItem.link));
                            a_childElement.setAttribute("target", "_self");
                            a_childElement.setAttribute("rel", "noopener noreferrer nofollow");
                            var img_childElement = document.createElement('img');
                            img_childElement.setAttribute("loading", "lazy");
                            img_childElement.setAttribute("data-src", DOMPurify.sanitize(featuredItem.imgsrc));
                            img_childElement.setAttribute("alt", DOMPurify.sanitize(featuredItem.imgalt));
                            img_childElement.className = "lazyload featured-in-image width-auto";
                            a_childElement.appendChild(img_childElement);
                            div_childElement.appendChild(a_childElement);
                            parentElement.appendChild(div_childElement);

                        }

                    }
                    init_featured_carousel();
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });

}

function getOurPartners() {
    $.ajax({
        type: "GET",
        url: "./assets/data/ourPartners.json",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('our-partners-data-div');
                        for (let featuredItem of result.data) {
                            // <div> 
                            //     <a href="{{featured.link}}" target="_self">
                            //         <img class="featured-in-image" src="{{featured.imgsrc}}" alt="{{featured.imgalt}}">
                            //     </a>
                            // </div>
                            var div_childElement = document.createElement('div');
                            div_childElement.className = "featured-in-item";
                            var a_childElement = document.createElement('a');
                            a_childElement.setAttribute("href", DOMPurify.sanitize(featuredItem.link));
                            a_childElement.setAttribute("target", "_self");
                            a_childElement.setAttribute("rel", "noopener noreferrer nofollow");
                            var img_childElement = document.createElement('img');
                            img_childElement.setAttribute("loading", "lazy");
                            img_childElement.setAttribute("data-src", DOMPurify.sanitize(featuredItem.imgsrc));
                            img_childElement.setAttribute("alt", DOMPurify.sanitize(featuredItem.imgalt));
                            img_childElement.className = "lazyload featured-in-image width-auto";
                            a_childElement.appendChild(img_childElement);
                            div_childElement.appendChild(a_childElement);
                            parentElement.appendChild(div_childElement);

                        }

                    }
                    init_our_partners_carousel();
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });

}


function getContainerImages(containerId) {
    $.ajax({
        type: "GET",
        url: "./assets/data/containerimages.json",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById(containerId);
                        for (let featuredItem of result.data) {

                            var div_childElement = document.createElement('div');
                            div_childElement.className = "card webcommonhealthcard";


                            var img_childElement = document.createElement('img');
                            img_childElement.setAttribute("loading", "lazy");
                            img_childElement.setAttribute("data-src", DOMPurify.sanitize(ASSETS_CONTAINER_LINK + featuredItem.imgsrc));
                            img_childElement.setAttribute("alt", DOMPurify.sanitize(featuredItem.imgalt));
                            img_childElement.className = "lazyload  commonmobsize";

                            var h5_childElement = document.createElement("h5");
                            h5_childElement.className = "font-weight-bold mt-2 heading5 commonmobsize";
                            h5_childElement.textContent = featuredItem.name;

                            var p_childElement = document.createElement("p");
                            p_childElement.className = "egd-theme-text font-weight-bolder heading5 commonmobsize";
                            p_childElement.setAttribute("role", "button");
                            p_childElement.textContent = "Consult now >";
                            p_childElement.setAttribute("onclick", "openWebsiteLinks('PORTAL_BASE_URL','user/login/patient','_blank');");

                            div_childElement.appendChild(img_childElement);
                            div_childElement.appendChild(h5_childElement);
                            div_childElement.appendChild(p_childElement);
                            parentElement.appendChild(div_childElement);

                        }

                    }
                    containerimages_carousel();
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });

}



function getDietData() {
    $.ajax({
        type: "GET",
        url: "./assets/data/diet.json",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('diet-data-div');
                        for (let featuredItem of result.data) {
                            var div_childElement = document.createElement('div');
                            div_childElement.className = "col-lg-3 col-md-6 col-sm-12 my-3";

                            var divimg_childElement = document.createElement('div');
                            divimg_childElement.className = "";
                            var img_childElement = document.createElement('img');
                            img_childElement.setAttribute("loading", "lazy");
                            img_childElement.setAttribute("data-src", DOMPurify.sanitize(featuredItem.imgsrc));
                            img_childElement.setAttribute("alt", DOMPurify.sanitize(featuredItem.imgalt));
                            img_childElement.className = "lazyload text-center";

                            var h5_childElement = document.createElement("h5");
                            h5_childElement.className = "font-weight-bolder mt-2 heading4 dietsectitle";
                            h5_childElement.textContent = featuredItem.name;


                            var p_childElement = document.createElement("p");
                            p_childElement.className = "heading5";
                            p_childElement.textContent = featuredItem.description;

                            var btndiv_childElement = document.createElement("div");
                            btndiv_childElement.className = "pt-5"
                            var button_childElement = document.createElement("button");
                            button_childElement.setAttribute("type", "button");
                            button_childElement.setAttribute("role", "button");
                            button_childElement.setAttribute("onclick", "openWebsiteLinks('PORTAL_BASE_URL','user/login/patient','_blank')");
                            button_childElement.className = "btn btn-primary booknowbtn font-weight-bolder";
                            button_childElement.textContent = "BOOK NOW";

                            btndiv_childElement.appendChild(button_childElement);


                            divimg_childElement.appendChild(img_childElement)
                            div_childElement.appendChild(divimg_childElement);
                            div_childElement.appendChild(h5_childElement);
                            div_childElement.appendChild(p_childElement);
                            div_childElement.appendChild(btndiv_childElement);
                            parentElement.appendChild(div_childElement);



                        }

                    }

                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });

}




// function browserbackbutton()
// {
//     const onBackButtonEvent = (e) => {

//         e.preventDefault();var currentLocation = window.location.pathname;

//         history.push(`${currentLocation}/mypage/new`)};

//         useEffect(() => {window.addEventListener('popstate', onBackButtonEvent);return () => {window.removeEventListener('popstate', onBackButtonEvent);

//         };}, [])
// }

function setYoutubeLink(id_name, yt_language_url) {
    var parentElement = document.getElementById(id_name);
    parentElement.setAttribute("src", DOMPurify.sanitize(yt_language_url + "?rel=0&modestbranding=1&autohide=1&showinfo=0&controls=0&autoplay=1"));
}


function setWidthNav() {
    var ele = document.getElementById("mySidepanel");
    ele ? ele.style.width = "0px" : ele;
}

function openNav() {
    var ele = document.getElementById("mySidepanel");
    ele ? ele.style.width = "300px" : ele;
}

$(document).ready(function () {
    $("#toggleButton").on("click", function () {
        $("#sidePanel").toggleClass("show");
    });

    $("#closeIcon").on("click", function () {
        $("#sidePanel").removeClass("show");
    });
});

function closeNav() {
    var ele = document.getElementById("mySidepanel");
    ele ? ele.style.width = "0px" : ele;


}

function toggleNav() {
    var ele = document.getElementById("mySidepanel");
    if (ele) {
        if (ele.style.width !== "0px") {
            closeNav()
        }
        else if (ele.style.width === "0px") {
            openNav()
        }
    }
}

$(window).scroll(function () {
    if ($(window).scrollTop() > 0) {
        closeNav()
    }
    // else {
    //     headerOn();
    // }
});

function onLinkChange() {
    // include_common_html();
    // include_gototopbutton();
    setWidthNav();
    setMainCountryDropdown('main-country-dropdown1');
    setMainCountryDropdown('main-country-dropdown');

    // goToID();

}
// added by sagar
function onLinkChange1() {
    // include_common_html();
    // include_gototopbutton();
    setWidthNav();
    //setMainCountryDropdown('main-country-dropdown');






    // goToID();

}


function formatErrorMessage(jqXHR, exception) {
    if (jqXHR.status === 0) {
        return ('Not connected.\nPlease verify your network connection.');
    } else if (jqXHR.status == 404) {
        return ('The requested page not found.');
    } else if (jqXHR.status == 401) {
        return ('Sorry!! You session has expired. Please login to continue access.');
    } else if (jqXHR.status == 500) {
        return ('Internal Server Error.');
    } else if (exception === 'parsererror') {
        return ('Requested JSON parse failed.');
    } else if (exception === 'timeout') {
        return ('Time out error.');
    } else if (exception === 'abort') {
        return ('Ajax request aborted.');
    } else {
        return ('Unknown error occured. Please try again.');
    }
}

function createDoctorsCards(parent_element, doctor_data) {
    for (let doctor of doctor_data) {


        // 	//**url depends upon where we are using 
        //** "./assets/images/defaults/default_doc_profile.jpg" url depends upon where we are using
        var c_doc_url = "./assets/images/defaults/default_doc_profile.jpg";
        if (Boolean(doctor.avatar_url)) {
            c_doc_url = doctor.avatar_url;
        }


        var div1_childElement = document.createElement('div');
        div1_childElement.className = "doctor-item-div doctor-card-col my-2";
        var div2_childElement = document.createElement('div');
        div2_childElement.className = "d-flex justify-space-between flex-column";
        var div3_childElement = document.createElement('div');
        div3_childElement.className = " d-flex flex-column align-items-center justify-content-center";
        var div4_childElement = document.createElement('div');
        div4_childElement.className = "d-none d-md-block view-profile-card-button-div mt-n25p";
        div4_childElement.setAttribute("onclick", "openProfile(" + "'doctor'" + "," + "'" + doctor.user_guid + "'" + ");");
        div4_childElement.setAttribute("role", "button");
        var div5_childElement = document.createElement('div');
        div5_childElement.className = "view-profile-card-button-content";
        div5_childElement.textContent = "View Profile";
        var div6_childElement = document.createElement('div');
        div6_childElement.className = "p-1 d-flex flex-column";
        div6_childElement.style.height = "110px";
        var div7_childElement = document.createElement('div');
        div7_childElement.className = "row justify-content-center";

        var img_childElement = document.createElement('img');
        img_childElement.setAttribute("loading", "lazy");
        img_childElement.setAttribute("data-src", DOMPurify.sanitize(c_doc_url));
        img_childElement.setAttribute("alt", DOMPurify.sanitize(doctor.first_name + " " + doctor.last_name + " - " + doctor.d_specialty_type.specialty_name));
        img_childElement.className = "lazyload card-img-top doctor-card-img";



        var h5_childElement = document.createElement("h5");
        h5_childElement.className = "card-title text-center font-weight-500 doctor-name heading4 notranslate";
        h5_childElement.textContent = doctor.first_name + " " + doctor.last_name;

        var p_childElement = document.createElement("p");
        p_childElement.className = "specialty-label card-text d-flex flex-column text-center heading5 notranslate";
        p_childElement.textContent = String(doctor.d_specialty_type.specialty_name).toUpperCase();

        var span1_childElement = document.createElement("span");
        span1_childElement.className = "mt-1 heading5 notranslate";
        span1_childElement.textContent = doctor.country.country_name;

        //Mobile view for doctor profile cards
        var button_childElement = document.createElement("button");
        button_childElement.setAttribute("type", "button");
        button_childElement.setAttribute("onclick", "openProfile(" + "'doctor'" + "," + "'" + doctor.user_guid + "'" + ");");
        button_childElement.className = "mt-auto mx-auto d-block d-md-none btn btn-default btn-primary banner-get-started-button width-max-content";
        button_childElement.textContent = "View Profile";
        // button_childElement.style.marginTop = "35px !important;";

        var span2_childElement = document.createElement("span");
        span2_childElement.className = "banner-get-started-label";
        span2_childElement.textContent = "View Profile";

        div4_childElement.appendChild(div5_childElement);
        div3_childElement.appendChild(img_childElement);

        div3_childElement.appendChild(div4_childElement);
        p_childElement.appendChild(span1_childElement);
        // button_childElement.appendChild(span2_childElement);
        // div7_childElement.appendChild(button_childElement)
        div6_childElement.appendChild(h5_childElement);
        div6_childElement.appendChild(p_childElement);
        // div6_childElement.appendChild(div7_childElement);

        div2_childElement.appendChild(div3_childElement);
        div2_childElement.appendChild(div6_childElement);
        div2_childElement.appendChild(button_childElement);
        div1_childElement.appendChild(div2_childElement);

        parent_element.appendChild(div1_childElement);

    }

}


function createSpecialtyCards(parent_element, specialty_data) {
    for (let specialty of specialty_data) {

        //** "./assets/images/defaults/default_speciality.png" url depends upon where we are using 
        var c_specialty_url = "./assets/images/defaults/default_speciality.png";
        if (Boolean(specialty.specialty_url)) {
            c_specialty_url = specialty.specialty_url
        }

        var div1_childElement = document.createElement('div');
        div1_childElement.className = "col-sm-6 mt-3 specialty-item-div";
        var div2_childElement = document.createElement('div');
        div2_childElement.className = "specialty-item card three-d-card w-100";
        var div_bindingElement = document.createElement('div');
        div_bindingElement.className = "";
        var div3_childElement = document.createElement('div');
        div3_childElement.className = "col-sm-12 d-flex";
        var div4_childElement = document.createElement('div');
        div4_childElement.className = "specialty-item-image";
        var div5_childElement = document.createElement('div');
        div5_childElement.className = "specialty-item-label my-auto heading5";
        div5_childElement.textContent = specialty.specialty_name;
        var div6_childElement = document.createElement('div');
        div6_childElement.className = "col-sm-12";
        var a_childElement = document.createElement('a');
        a_childElement.className = "speciality-view-doctors float-right mb-2";
        a_childElement.textContent = "View Doctors"
        a_childElement.href = "view-doctors?specialty_id=" + specialty.id;

        var img_childElement = document.createElement('img');
        img_childElement.setAttribute("loading", "lazy");
        img_childElement.setAttribute("data-src", DOMPurify.sanitize(c_specialty_url));
        img_childElement.setAttribute("alt", DOMPurify.sanitize(specialty.specialty_name));
        img_childElement.className = "lazyload";



        div4_childElement.appendChild(img_childElement);
        div3_childElement.appendChild(div4_childElement);
        div3_childElement.appendChild(div5_childElement);
        div_bindingElement.appendChild(div3_childElement);
        div6_childElement.appendChild(a_childElement);
        div_bindingElement.appendChild(div6_childElement);
        div2_childElement.appendChild(div_bindingElement);
        div1_childElement.appendChild(div2_childElement);
        parent_element.appendChild(div1_childElement);


    }

}

function createSpecialityCarousel(parent_element, specialty_data) {

    for (let specialty of specialty_data) {
        var parentElement = document.getElementById('specialty-data-div');
        //** "./assets/images/defaults/default_speciality.png" url depends upon where we are using 
        var c_specialty_url = "./assets/images/defaults/default_speciality.png";
        if (Boolean(specialty.specialty_url)) {
            c_specialty_url = specialty.specialty_url
        }



        var div_childElement = document.createElement('div');
        div_childElement.className = "specialty-item-div text-center";

        var img_childElement = document.createElement('img');
        var img_childElement = document.createElement('img');
        img_childElement.setAttribute("loading", "lazy");
        img_childElement.setAttribute("data-src", DOMPurify.sanitize(c_specialty_url));
        img_childElement.setAttribute("alt", DOMPurify.sanitize(specialty.specialty_name));
        img_childElement.className = "lazyload specialtyimg m-auto";
        var div5_childElement = document.createElement('div');
        div5_childElement.className = "specialty-item-label my-auto heading7 font-weight-600";
        div5_childElement.textContent = specialty.specialty_name;
        var a_childElement = document.createElement('a');
        a_childElement.className = "speciality-view-doctors heading8";
        a_childElement.textContent = "View Doctors"
        a_childElement.href = "view-doctors?specialty_id=" + specialty.id;
        div_childElement.appendChild(img_childElement);
        div_childElement.appendChild(div5_childElement);
        div_childElement.appendChild(a_childElement);
        parent_element.appendChild(div_childElement);
    }
    init_specialty_carousel();
}

function getFeaturedTestimonials() {
    $.ajax({
        async: true,
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/testimonial/GetAll/covid/Featured",
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {

                        var parentElement = document.getElementById('testimonial-data-div');
                        for (let testimonial of result.data) {
                            var testimonial_img_url = "./assets/images/home/testimonial-quote1.png";
                            var testimonialfooter_img_url = "./assets/images/home/user.png";
                            var div1_childElement = document.createElement('div');
                            div1_childElement.className = "mt-5 container mx-4";
                            var div2_childElement = document.createElement('div');
                            div2_childElement.className = "card testimonialnewcard";
                            var divimg_childElement = document.createElement('div');
                            divimg_childElement.className = "testimonialimgdiv";
                            var img1_childElement = document.createElement('img');
                            img1_childElement.setAttribute("loading", "lazy");
                            img1_childElement.className = "lazyload testimonialimg";
                            img1_childElement.setAttribute("data-src", DOMPurify.sanitize(testimonial_img_url));
                            img1_childElement.setAttribute("alt", "testimonial-image");

                            divimg_childElement.appendChild(img1_childElement);

                            var div_titleElement = document.createElement('div');
                            div_titleElement.className = "card-body testimonial-message";
                            var ptitle_childElement = document.createElement('p');
                            ptitle_childElement.className = "";
                            ptitle_childElement.textContent = testimonial.message;

                            div_titleElement.appendChild(ptitle_childElement);

                            var div_testimonialfooter = document.createElement('div');
                            div_testimonialfooter.className = "card-footer testimonialcardfooter";
                            var div_footerrow = document.createElement('div');
                            div_footerrow.className = "row";

                            var div_testimonialfooterimg = document.createElement('img');
                            div_testimonialfooterimg.setAttribute("loading", "lazy");
                            div_testimonialfooterimg.className = "lazyload testimonialuserimg";
                            div_testimonialfooterimg.setAttribute("data-src", DOMPurify.sanitize(testimonialfooter_img_url));
                            div_testimonialfooterimg.setAttribute("alt", "testimonial-image");

                            var div_footertext = document.createElement("div");
                            div_footertext.className = "testimonialfootertext mt-4";
                            var p1_childElement = document.createElement("p");
                            p1_childElement.className = "mb-0";
                            for (let i = 0; i < Number(testimonial.rating); i++) {
                                var span_childElement = document.createElement("span");
                                span_childElement.className = "fa fa-star mr-1 egd-fa-click star-rating-font";
                                p1_childElement.appendChild(span_childElement);
                            }

                            for (let i = 0; i < 5 - Number(testimonial.rating); i++) {
                                var span_childElement = document.createElement("span");
                                span_childElement.className = "fa fa-star-o mr-1 egd-fa-click star-rating-font";
                                p1_childElement.appendChild(span_childElement);
                            }
                            var p2_childElement = document.createElement("p");
                            p2_childElement.className = "mt-0 mb-0 font-weight-600 notranslate";
                            p2_childElement.textContent = testimonial.name;

                            var p3_childElement = document.createElement("p");
                            p3_childElement.className = "mt-0 notranslate";
                            p3_childElement.textContent = testimonial.country.country_name;

                            div_footertext.appendChild(p1_childElement);
                            div_footertext.appendChild(p2_childElement);
                            div_footertext.appendChild(p3_childElement);

                            div_footerrow.appendChild(div_testimonialfooterimg);
                            div_footerrow.appendChild(div_footertext);
                            div_testimonialfooter.appendChild(div_footerrow);



                            div2_childElement.appendChild(divimg_childElement);
                            div2_childElement.appendChild(div_titleElement);
                            div2_childElement.appendChild(div_testimonialfooter);

                            div1_childElement.appendChild(div2_childElement);

                            parentElement.appendChild(div1_childElement);

                        }


                    }
                    init_testimonial_carousel();
                }
                else if (!Boolean(result.success)) {
                    //error handling
                }
            }

        })
        .fail(function (jqXHR, textStatus, errorThrown) {


        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}

function getFeaturedSpecialties() {
    $.ajax({
        async: true,
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/specialty/GetFeatured",
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('specialty-data-div');
                        createSpecialityCarousel(parentElement, result.data);
                    }
                }
                else if (!Boolean(result.success)) {
                    //error handling
                }
            }

        })
        .fail(function (jqXHR, textStatus, errorThrown) {


        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}

function getSates() {
    var selected_country = document.getElementById('view-doctors-country-dropdown-options').value;
    var country_id = null;
    if (Boolean(selected_country)) {
        if (selected_country == "ALL") {
            country_id = null;
        }
        else {
            country_id = Number(selected_country)
        }
    }

    if (Boolean(country_id)) {
        $.ajax({
            async: true,
            type: "GET",
            url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/country/GetStates/" + country_id,
            headers: {
                'platform': 'web',
            },
            contentType: "application/json",
            success: function (response) {

            },
            error: function (jqXHR, textStatus, errorThrown) {

            },
        })
            .done(function (result, textStatus, jqXHR) {

                if (Boolean(result)) {
                    // if (Boolean(result.success)) {
                    var parent_element = document.getElementById('view-doctors-state-dropdown-options');
                    parent_element.innerHTML = "";

                    var option_childElement = document.createElement('option');
                    option_childElement.setAttribute("value", "");
                    option_childElement.setAttribute("disabled", true);
                    // option_childElement.className = "pricing-coption";
                    option_childElement.textContent = "Select State";
                    parent_element.appendChild(option_childElement);

                    var option_childElement = document.createElement('option');
                    option_childElement.setAttribute("value", -1);
                    // option_childElement.setAttribute("disabled", true);
                    // option_childElement.className = "pricing-coption";
                    option_childElement.textContent = "ALL";
                    parent_element.appendChild(option_childElement);

                    if (result.length > 0) {
                        for (let state of result) {
                            var option_childElement = document.createElement('option');
                            option_childElement.setAttribute("value", state.id);
                            // option_childElement.setAttribute("disabled", true);
                            // option_childElement.className = "pricing-coption";
                            option_childElement.textContent = state.state_name;
                            parent_element.appendChild(option_childElement);
                        }
                    }
                    // }
                    // else if (!Boolean(result.success)) {

                    // }
                    document.getElementById("view-doctors-state-dropdown-options-div").style.display = "unset";
                }
                else if (!Boolean(result)) {
                    document.getElementById("view-doctors-state-dropdown-options-div").style.display = "none";
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {

            })
            .always(function (jqXHR, textStatus, errorThrown) {

            });

    }

}

function onChangeStateViewDoctors() {
    var params = new URLSearchParams(window.location.search.substring(1));
    var specialty_id = params.get("specialty_id");
    var selected_country = Number(document.getElementById('view-doctors-country-dropdown-options').value);
    var selected_state = Number(document.getElementById('view-doctors-state-dropdown-options').value);
    var specialty_id_array = [];
    var country_id_array = [];
    var state_id_array = [];

    if (Boolean(specialty_id)) {
        specialty_id_array.push(specialty_id);
    }

    if (Boolean(selected_country)) {
        if (selected_country == -1) {
            country_id_array = [];
        }
        else {
            country_id_array.push(selected_country);
        }
    }
    else if (!Boolean(selected_country)) {
        country_id_array = [];
    }

    if (Boolean(selected_state)) {
        if (selected_state == -1) {
            state_id_array = [];
        }
        else {
            state_id_array.push(selected_state);
        }
    }
    else if (!Boolean(selected_state)) {
        state_id_array = [];
    }


    var request_body_data = {
        specialty_id: specialty_id_array,
        country_id: country_id_array,
        state_id: state_id_array
    }
    $.ajax({
        async: true,
        type: "POST",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/homepage/doctors/fetchall",
        data: JSON.stringify(request_body_data),
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {
            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('all-doctor-data-div');
                        parentElement.innerHTML = "";

                        if (request_body_data.specialty_id.length > 0) {
                            var c_specialty_url = "./assets/images/defaults/default_speciality.png";
                            if (Boolean(result.data[0].d_specialty_type.specialty_url)) {
                                c_specialty_url = result.data[0].d_specialty_type.specialty_url;
                            }

                            var div1_childElement = document.createElement('div');
                            div1_childElement.className = "col-sm-12 my-5";
                            var div2_childElement = document.createElement('div');
                            div2_childElement.className = "col-sm-12 d-flex justify-content-center";
                            var div3_childElement = document.createElement('div');
                            div3_childElement.className = "col-sm-12";
                            var div4_childElement = document.createElement('div');
                            div4_childElement.className = "specialty-item-image-view-doctor";
                            var div5_childElement = document.createElement('div');
                            div5_childElement.className = "specialty-item-label ml-2 my-auto h2 egd-theme-text font-weight-bolder";
                            div5_childElement.textContent = result.data[0].d_specialty_type.specialty_name;

                            // var h2_childElement = document.createElement('p');
                            // h2_childElement.className = "text-center";
                            // h2_childElement.textContent = result.data[0].speciality.specialty_name;

                            var p_childElement = document.createElement('p');
                            p_childElement.className = "text-center";
                            p_childElement.textContent = result.data[0].d_specialty_type.homepage_tag_line;

                            var img_childElement = document.createElement('img');
                            img_childElement.setAttribute("loading", "lazy");
                            img_childElement.setAttribute("data-src", DOMPurify.sanitize(c_specialty_url));
                            img_childElement.setAttribute("alt", DOMPurify.sanitize(result.data[0].d_specialty_type.specialty_name));
                            img_childElement.className = "lazyload";

                            div4_childElement.appendChild(img_childElement);
                            // div5_childElement.appendChild(h2_childElement);
                            div2_childElement.appendChild(div4_childElement);
                            div2_childElement.appendChild(div5_childElement);
                            div3_childElement.appendChild(p_childElement);
                            div1_childElement.appendChild(div2_childElement);
                            div1_childElement.appendChild(div3_childElement);

                            parentElement.appendChild(div1_childElement);
                        }

                        createDoctorsCards(parentElement, result.data);
                    }
                }
                else if (!Boolean(result.success)) {
                    var parentElement = document.getElementById('all-doctor-data-div');
                    parentElement.innerHTML = "";
                    var div1_childElement = document.createElement('div');
                    div1_childElement.className = "col-sm-12 my-5";
                    var h2_childElement = document.createElement('h2');
                    h2_childElement.className = "text-center egd-theme-text font-weight-bold";
                    h2_childElement.textContent = "No Doctors Found"

                    div1_childElement.appendChild(h2_childElement);
                    parentElement.appendChild(div1_childElement);
                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });

}


function onChangeCountryViewDoctors() {
    var params = new URLSearchParams(window.location.search.substring(1));
    var specialty_id = params.get("specialty_id");
    var selected_country = Number(document.getElementById('view-doctors-country-dropdown-options').value);
    var specialty_id_array = [];
    var country_id_array = [];
    var state_id_array = [];

    if (Boolean(specialty_id)) {
        specialty_id_array.push(specialty_id);
    }
    if (Boolean(selected_country)) {
        if (selected_country == -1) {
            country_id_array = [];
            document.getElementById("view-doctors-state-dropdown-options-div").style.display = "none";
        }
        else {
            country_id_array.push(selected_country);
            getSates();
        }
    }
    else if (!Boolean(selected_country)) {
        country_id_array = [];
        document.getElementById("view-doctors-state-dropdown-options-div").style.display = "none";
    }

    var request_body_data = {
        specialty_id: specialty_id_array,
        country_id: country_id_array,
        state_id: state_id_array
    }
    $.ajax({
        async: true,
        type: "POST",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/homepage/doctors/fetchall",
        data: JSON.stringify(request_body_data),
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {
            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('all-doctor-data-div');
                        parentElement.innerHTML = "";

                        if (request_body_data.specialty_id.length > 0) {
                            var c_specialty_url = "./assets/images/defaults/default_speciality.png";
                            if (Boolean(result.data[0].d_specialty_type.specialty_url)) {
                                c_specialty_url = result.data[0].d_specialty_type.specialty_url;
                            }

                            var div1_childElement = document.createElement('div');
                            div1_childElement.className = "col-sm-12 my-5";
                            var div2_childElement = document.createElement('div');
                            div2_childElement.className = "col-sm-12 d-flex justify-content-center";
                            var div3_childElement = document.createElement('div');
                            div3_childElement.className = "col-sm-12";
                            var div4_childElement = document.createElement('div');
                            div4_childElement.className = "specialty-item-image-view-doctor";
                            var div5_childElement = document.createElement('div');
                            div5_childElement.className = "specialty-item-label ml-2 my-auto h2 egd-theme-text font-weight-bolder";
                            div5_childElement.textContent = result.data[0].d_specialty_type.specialty_name;

                            // var h2_childElement = document.createElement('p');
                            // h2_childElement.className = "text-center";
                            // h2_childElement.textContent = result.data[0].speciality.specialty_name;

                            var p_childElement = document.createElement('p');
                            p_childElement.className = "text-center";
                            p_childElement.textContent = result.data[0].d_specialty_type.homepage_tag_line;

                            var img_childElement = document.createElement('img');
                            img_childElement.setAttribute("loading", "lazy");
                            img_childElement.setAttribute("data-src", DOMPurify.sanitize(c_specialty_url));
                            img_childElement.setAttribute("alt", DOMPurify.sanitize(result.data[0].d_specialty_type.specialty_name));
                            img_childElement.className = "lazyload";

                            div4_childElement.appendChild(img_childElement);
                            // div5_childElement.appendChild(h2_childElement);
                            div2_childElement.appendChild(div4_childElement);
                            div2_childElement.appendChild(div5_childElement);
                            div3_childElement.appendChild(p_childElement);
                            div1_childElement.appendChild(div2_childElement);
                            div1_childElement.appendChild(div3_childElement);

                            parentElement.appendChild(div1_childElement);
                        }

                        createDoctorsCards(parentElement, result.data);
                    }
                }
                else if (!Boolean(result.success)) {
                    var parentElement = document.getElementById('all-doctor-data-div');
                    parentElement.innerHTML = "";
                    var div1_childElement = document.createElement('div');
                    div1_childElement.className = "col-sm-12 my-5";
                    var h2_childElement = document.createElement('h2');
                    h2_childElement.className = "text-center egd-theme-text font-weight-bold";
                    h2_childElement.textContent = "No Doctors Found"

                    div1_childElement.appendChild(h2_childElement);
                    parentElement.appendChild(div1_childElement);
                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });

}

function getViewAllSpecialties() {
    var request_parameters = {
        has_doctors: true
    }
    $.ajax({
        async: true,
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/specialty/GetAll",
        data: request_parameters,
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {

                        var parentElement = document.getElementById('all-specialty-data-div');

                        createSpecialtyCards(parentElement, result.data);
                    }
                }
                else if (!Boolean(result.success)) {
                    //error handling
                }
            }

        })
        .fail(function (jqXHR, textStatus, errorThrown) {


        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}

function open_home_news(link) {
    var sanitized_link = DOMPurify.sanitize(link)
    // window.open(sanitized_link, "_self");
    const a_childElement = document.createElement('a');

    Object.assign(a_childElement, {
        target: "_self",
        href: sanitized_link,
        rel: "noopener noreferrer nofollow"
    }).click()

}

function getFeaturedNews() {

    $.ajax({
        async: true,
        type: "GET",
        url: "./assets/data/NewsData.json",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('home-news-data-div');
                        for (let home_news of result.data) {

                            var main_childElement = document.createElement('div');
                            main_childElement.className = "mainnewsndiv";
                            var maincol_childElement = document.createElement('div');
                            maincol_childElement.className = "maincolnewsdiv";
                            var imgdiv_childElement = document.createElement('div');
                            imgdiv_childElement.className = "imgdiv";

                            var imgchild_divElement = document.createElement('div');
                            imgchild_divElement.className = "mainnews"
                            var img_childElement = document.createElement('img');
                            img_childElement.setAttribute("loading", "lazy");
                            img_childElement.setAttribute("data-src", DOMPurify.sanitize(home_news.imgsrc));
                            img_childElement.setAttribute("alt", DOMPurify.sanitize(home_news.alt_name));
                            img_childElement.className = "lazyload newsimg mt-2";

                            var div3_childElement = document.createElement('div');
                            div3_childElement.className = "home-news-heading heading3 font-weight-bold";
                            div3_childElement.textContent = home_news.title
                            var div4_childElement = document.createElement('div');
                            div4_childElement.className = "home-news-description heading5";
                            div4_childElement.textContent = home_news.heading

                            imgchild_divElement.appendChild(img_childElement);
                            imgdiv_childElement.appendChild(imgchild_divElement);
                            imgdiv_childElement.appendChild(div3_childElement);
                            imgdiv_childElement.appendChild(div4_childElement);

                            var btn_childdivElement = document.createElement('div');
                            btn_childdivElement.className = "mainbtndiv text-left";
                            var button_childElement = document.createElement("p");
                            button_childElement.setAttribute("role", "button");
                            button_childElement.className = "newsbtn font-weight-bolder ml-3";
                            button_childElement.setAttribute("onclick", "open_home_news(" + "'" + DOMPurify.sanitize(home_news.link) + "'" + ");");

                            var span_childElement = document.createElement("span");
                            span_childElement.className = "pb-3 readmorenews";
                            span_childElement.textContent = "+ Read More";

                            button_childElement.appendChild(span_childElement);
                            btn_childdivElement.appendChild(button_childElement);

                            maincol_childElement.appendChild(imgdiv_childElement);
                            maincol_childElement.appendChild(btn_childdivElement);

                            main_childElement.appendChild(maincol_childElement);

                            parentElement.appendChild(main_childElement);


                        }
                    }
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}




function getHealthcareVideos() {

    $.ajax({
        async: true,
        type: "GET",
        url: "./assets/data/healthcarevideos.json",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('healthcarevideos');
                        for (let video of result.data) {

                            var div_childElement = document.createElement('div');
                            div_childElement.className = "col-md-6 col-sm-12 mobcenterimg";

                            var rowdiv_childElement = document.createElement('div');
                            rowdiv_childElement.className = "row my-3"

                            var imgdiv_childElement = document.createElement('div');
                            imgdiv_childElement.className = "videosimgdiv col-md-3 col-sm-12";
                            var img_childElement = document.createElement('img');
                            img_childElement.setAttribute("loading", "lazy");
                            img_childElement.setAttribute("data-src", video.imgsrc);
                            img_childElement.setAttribute("alt", video.imgalt);
                            img_childElement.className = "lazyload specialtyvideospageimg";

                            imgdiv_childElement.appendChild(img_childElement);

                            var contentdiv_childElement = document.createElement('div');
                            contentdiv_childElement.className = "videoscontentdiv col-md-8 col-sm-12 ";

                            var p1_childElement = document.createElement("p");
                            p1_childElement.className = "heading4 mt-2 font-weight-600 videonameheading";
                            p1_childElement.textContent = video.name;

                            var button_childElement = document.createElement("button");
                            button_childElement.setAttribute("type", "button");
                            button_childElement.setAttribute("onclick", "open_link(" + "'" + video.youtube_link + "'" + "," + "'_blank'" + ");");
                            button_childElement.className = "btn btn-default btn-primary healthvideobtn";
                            button_childElement.textContent = "Watch Videos";

                            // var span2_childElement = document.createElement("span");
                            // span2_childElement.className = "banner-get-started-label";
                            // span2_childElement.textContent = "Watch Videos";

                            contentdiv_childElement.appendChild(p1_childElement);
                            contentdiv_childElement.appendChild(button_childElement);

                            rowdiv_childElement.appendChild(imgdiv_childElement)
                            rowdiv_childElement.appendChild(contentdiv_childElement);

                            div_childElement.appendChild(rowdiv_childElement);

                            parentElement.appendChild(div_childElement);


                        }
                    }
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}


function isMobileDevice() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

function scrollToId(id_name) {
    document.getElementById(id_name).scrollIntoView({
        behavior: 'smooth'
    });
}

function scrollToIDAfterLoadingCards(hash_id) {
    window.scrollTo(0, $(hash_id).offset().top - 600);
}

function show_doctors_init(div_id, user_type) {
    n = $(div_id).length;


    if (isMobileDevice()) {
        CURRENT_DOCTOR_LIST_SIZE = MOBILE_DOCTOR_LIST_SIZE;
        DEFAULT_DOCTOR_LIST_SIZE = MOBILE_DOCTOR_LIST_SIZE;
        CURRENT_NUTRITIONIST_LIST_SIZE = MOBILE_NUTRITIONIST_LIST_SIZE;
        DEFAULT_NUTRITIONIST_LIST_SIZE = MOBILE_NUTRITIONIST_LIST_SIZE;

    }
    x = 0;
    if (user_type == "doctor") {
        x = CURRENT_DOCTOR_LIST_SIZE;
    }
    else {
        x = CURRENT_NUTRITIONIST_LIST_SIZE;
    }

    $(div_id).slice(0, x).css("display", "grid");
    if (user_type == "doctor") {
        $('#showLess').hide();
        if (n <= CURRENT_DOCTOR_LIST_SIZE) {
            $('#loadMore').hide();
        }
    }
    else {
        $('#showLess1').hide();
        if (n <= CURRENT_NUTRITIONIST_LIST_SIZE) {
            $('#loadMore1').hide();
        }
    }
}

function load_more_doctors() {
    n = $('#doctor-data-div .doctor-item-div').length;
    x = CURRENT_DOCTOR_LIST_SIZE;

    CURRENT_DOCTOR_LIST_SIZE = (x + INCREMENTAL_DOCTOR_LIST_SIZE <= n) ? x + INCREMENTAL_DOCTOR_LIST_SIZE : n;

    $('#doctor-data-div .doctor-item-div').slice(0, CURRENT_DOCTOR_LIST_SIZE).css("display", "grid");
    $('#showLess').show();
    if (CURRENT_DOCTOR_LIST_SIZE == n) {

        $('#loadMore').hide();
    }
    scrollToIDAfterLoadingCards("#showLess");
    // scrollToId('showLess');
}

function showmobdiv(hash, set_hash) {
    const hash_exists = document.querySelector(hash);
    if (!hash_exists) return;
    $('#togglemobile').show();
    document.getElementById("togglemobile").className = "d-block";
    $('#footersectionshow').show();
    document.getElementById("footersectionshow").className = "d-block";

    if (set_hash) window.location = hash;
    const href = window.location.href;
    //if(!href.includes('explore_more')) window.location.href = href + '?explore_more=true';
    if (hash) {
        window.scrollTo(0, $(hash).offset().top - 140);
        return;
    }
    window.scrollBy(0, 290);
}

function OnClickConsultationType(relative_path) {
    //const y_pos = window.scrollY();
    window.location = "#consultationtypes";
    window.location.assign(window.location.origin + relative_path);
}
function offercodecopy() {
    var copybtn = document.getElementById("copy-btn1");
    var link1 = document.getElementById("link1");

    copybtn.onclick = function () {

        navigator.clipboard.writeText(link1.innerHTML);
        var dis = document.getElementById("sh")
        dis.classList.toggle("up");
    }

}

function toggledivmob() {
    $('mobileshowcontainer').hide();
    $('#togglemobile').hide();
    $('webcontainer').hide();
    if (isMobileDevice()) {
        $('mobileshowcontainer').show();
    }
    else {
        $('#togglemobile').show();
        $('webcontainer').show();
        $('mobileshowcontainer').hide();
    }
}
function scrollourpartners() {
    if (isMobileDevice()) {
        $('#togglemobile').show();

    }
}
function getExploreMore() {
    // const queryString = window.location.search;    
    // const urlParams = new URLSearchParams(queryString);
    // const explore_more = Boolean(JSON.parse(urlParams.get('explore_more')));        
    // if(explore_more){
    //     showmobdiv();
    // }
    var hash = window.location.hash;
    if (!hash) return;
    // const explore_more = Boolean(JSON.parse(urlParams.get('consultationtypes')));        
    showmobdiv(hash);
}

function load_more_nutritionist() {
    n = $('#dietician-data-div .doctor-item-div').length;

    x = CURRENT_NUTRITIONIST_LIST_SIZE;

    CURRENT_NUTRITIONIST_LIST_SIZE = (x + INCREMENTAL_NUTRITIONIST_LIST_SIZE <= n) ? x + INCREMENTAL_NUTRITIONIST_LIST_SIZE : n;
    // $('#doctor-data-div .doctor-item-div').slice(0, CURRENT_DOCTOR_LIST_SIZE).show();
    $('#dietician-data-div .doctor-item-div').slice(0, CURRENT_NUTRITIONIST_LIST_SIZE).css("display", "grid");
    $('#showLess1').show();
    if (CURRENT_NUTRITIONIST_LIST_SIZE == n) {

        $('#loadMore1').hide();
    }
    scrollToIDAfterLoadingCards("#showLess1");
    // scrollToId('showLess1');
}

function show_less_doctors() {
    n = $('#doctor-data-div .doctor-item-div').length;
    x = CURRENT_DOCTOR_LIST_SIZE;

    decrment_size = (x % INCREMENTAL_DOCTOR_LIST_SIZE == 0) ? INCREMENTAL_DOCTOR_LIST_SIZE : x % INCREMENTAL_DOCTOR_LIST_SIZE;

    CURRENT_DOCTOR_LIST_SIZE = (x - decrment_size < 0) ? decrment_size : x - decrment_size;

    // $('#doctor-data-div .doctor-item-div').slice(CURRENT_DOCTOR_LIST_SIZE, n).hide(); 
    $('#doctor-data-div .doctor-item-div').slice(CURRENT_DOCTOR_LIST_SIZE, n).css("display", "none");
    $('#loadMore').show();
    $('#showLess').show();
    if (CURRENT_DOCTOR_LIST_SIZE == DEFAULT_DOCTOR_LIST_SIZE) {

        $('#showLess').hide();
    }
    scrollToIDAfterLoadingCards("#loadMore");
    // scrollToId('loadMore');

}

function show_less_nutritionist() {
    n = $('#dietician-data-div .doctor-item-div').length;
    x = CURRENT_NUTRITIONIST_LIST_SIZE;

    decrment_size = (x % INCREMENTAL_NUTRITIONIST_LIST_SIZE == 0) ? INCREMENTAL_NUTRITIONIST_LIST_SIZE : x % INCREMENTAL_NUTRITIONIST_LIST_SIZE;

    CURRENT_NUTRITIONIST_LIST_SIZE = (x - decrment_size < 0) ? decrment_size : x - decrment_size;

    // $('#doctor-data-div .doctor-item-div').slice(CURRENT_DOCTOR_LIST_SIZE, n).hide(); 
    $('#dietician-data-div .doctor-item-div').slice(CURRENT_NUTRITIONIST_LIST_SIZE, n).css("display", "none");
    $('#loadMore1').show();
    $('#showLess1').show();
    if (CURRENT_NUTRITIONIST_LIST_SIZE == DEFAULT_NUTRITIONIST_LIST_SIZE) {

        $('#showLess1').hide();
    }
    scrollToIDAfterLoadingCards("#loadMore1");
    // scrollToId('loadMore1');
}

function validator_oncology(recaptchaToken) {
    var name = document.forms.RegForm.user_name;
    var email = document.forms.RegForm.user_email;
    var phone_code = document.forms.RegForm.oncology_phone_code.value;
    var phone_number = document.forms.RegForm.user_phone_number;
    var final_phone_number = phone_code.concat(phone_number.value);
    //var recaptcha = grecaptcha.getResponse();
    let data = {
        name: name.value,
        email: email.value,
        phone_code: phone_code,
        phone_number: phone_number.value,
        final_phone_number: final_phone_number,
        recaptcha: recaptchaToken,
    }

    var regEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;  //Javascript reGex for Email Validation.
    var regPhone = /^[0-9-+\s()]{6,16}/;                                        // Javascript reGex for Phone Number validation.
    var regName = /^[a-zA-Z0-9^\s]+$/;                                    // Javascript reGex for Name validation
    let form = {
        validator: true,
        data: data,
    }
    document.getElementById('name_error').textContent = "";
    document.getElementById('email_error').textContent = "";
    document.getElementById('phone_error').textContent = "";
    document.getElementById('form_submit_api_error').textContent = "";
    document.getElementById('form_submit_api_success').textContent = "";
    document.getElementById('recaptcha_error').textContent = "";
    if (!Boolean(name.value)) {
        document.getElementById('name_error').textContent = "Please enter name";
        name.focus();
        form.validator = false;
    }
    else if (!regName.test(name.value)) {
        document.getElementById('name_error').textContent = "Invalid name entered";
        name.focus();
        form.validator = false;
    }
    if (!Boolean(email.value)) {
        document.getElementById('email_error').textContent = "Please enter email";
        email.focus();
        form.validator = false;
    }
    else if (!regEmail.test(email.value)) {
        document.getElementById('email_error').textContent = "Invalid email entered";
        email.focus();
        form.validator = false;
    }
    if (!Boolean(phone_number.value)) {
        document.getElementById('phone_error').textContent = "Enter Phone Number";
        phone_number.focus();
        form.validator = false;
    }
    else if (!regPhone.test(phone_number.value)) {
        document.getElementById('phone_error').textContent = "Invalid Phone Number.";
        phone_number.focus();
        form.validator = false;
    }
    if (!Boolean(recaptcha)) {
        document.getElementById('recaptcha_error').textContent = "You can't proceed! Please solve recaptcha";
        form.validator = false;
    }
    else {
        grecaptcha.reset();
    }
    return form;
}

function validatorLicencing() {
    var phoneCode = document.forms.RegForm3.licencing_phone_code.value;
    var phoneNumberElement = document.forms.RegForm3.licencing_user_phone_number;
    var phoneNumber = phoneNumberElement.value;
    var finalPhoneNumber = phoneCode + phoneNumber;
    var recaptcha = grecaptcha.getResponse();

    let data = {
        phone_code: phoneCode,
        phone_number: phoneNumber,
        final_phone_number: finalPhoneNumber,
        recaptcha: recaptcha,
    }
    var regPhone = /^[0-9-+\s()]{6,16}/;                                        // Javascript reGex for Phone Number validation.
    let form = {
        validator: true,
        data: data,
    }
    document.getElementById('phone_error_licencing').textContent = "";
    document.getElementById('form_submit_api_error_licencing').textContent = "";
    document.getElementById('form_submit_api_success_licencing').textContent = "";
    document.getElementById('recaptcha_error_licencing').textContent = "";
    if (!Boolean(phoneNumber)) {
        document.getElementById('phone_error_licencing').textContent = "Enter Phone Number";
        phoneNumberElement.focus();
        form.validator = false;
    }
    else if (!regPhone.test(phoneNumber)) {
        document.getElementById('phone_error_licencing').textContent = "Invalid Phone Number.";
        phoneNumberElement.focus();
        form.validator = false;
    }
    if (!Boolean(recaptcha)) {
        document.getElementById('recaptcha_error_licencing').textContent = "You can't proceed! Please solve recaptcha";
        form.validator = false;
    }
    else {
        grecaptcha.reset();
    }
    return form;
}


function validator_buisness() {
    var name = document.forms.RegForm.user_name_bpage;
    var organization_name = document.forms.RegForm.organization_name;
    var contact_email = document.forms.RegForm.user_email_bpage;
    var query = document.forms.RegForm.query_bpage;
    var phone_code = document.forms.RegForm.bpage_phone_code.value;
    var contact_number = document.forms.RegForm.user_phone_number_bpage;
    var final_phone_number = phone_code.concat(contact_number.value);
    var recaptcha = grecaptcha.getResponse();
    let data = {
        name: name.value,
        organization_name: organization_name.value,
        contact_email: contact_email.value,
        query: query.value,
        phone_code: phone_code,
        contact_number: contact_number.value,
        final_phone_number: final_phone_number,
        recaptcha: recaptcha,
    }

    var regEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;  //Javascript reGex for Email Validation.
    var regPhone = /^[0-9-+\s()]{6,16}/;                                        // Javascript reGex for Phone Number validation.
    var regName = /^[a-zA-Z0-9^\s]+$/;                                    // Javascript reGex for Name validation
    let form = {
        validator: true,
        data: data,
    }
    document.getElementById('name_error_bpage').textContent = "";
    document.getElementById('business_name_error_bpage').textContent = "";
    document.getElementById('email_error_bpage').textContent = "";
    document.getElementById('phone_error_bpage').textContent = "";
    document.getElementById('query_error_bpage').textContent = "";
    document.getElementById('form_submit_api_error_bpage').textContent = "";
    document.getElementById('form_submit_api_success_bpage').textContent = "";
    document.getElementById('recaptcha_error_bpage').textContent = "";
    if (!Boolean(name.value)) {
        document.getElementById('name_error_bpage').textContent = "Please enter name";
        name.focus();
        form.validator = false;
    }
    else if (!regName.test(name.value)) {
        document.getElementById('name_error_bpage').textContent = "Invalid name entered";
        name.focus();
        form.validator = false;
    }
    if (!Boolean(organization_name.value)) {
        document.getElementById('business_name_error_bpage').textContent = "Please enter Organization name";
        organization_name.focus();
        form.validator = false;
    }
    else if (!regName.test(organization_name.value)) {
        document.getElementById('business_name_error_bpage').textContent = "Invalid name entered";
        organization_name.focus();
        form.validator = false;
    }
    if (!Boolean(query.value)) {
        document.getElementById('query_error_bpage').textContent = "Please enter query";
        query.focus();
        form.validator = false;
    }
    else if (!regName.test(query.value)) {
        document.getElementById('query_error_bpage').textContent = "Invalid query entered";
        query.focus();
        form.validator = false;
    }
    if (!Boolean(contact_email.value)) {
        document.getElementById('email_error_bpage').textContent = "Please enter email";
        contact_email.focus();
        form.validator = false;
    }
    else if (!regEmail.test(contact_email.value)) {
        document.getElementById('email_error_bpage').textContent = "Invalid email entered";
        contact_email.focus();
        form.validator = false;
    }
    if (!Boolean(contact_number.value)) {
        document.getElementById('phone_error_bpage').textContent = "Enter Phone Number";
        contact_number.focus();
        form.validator = false;
    }
    else if (!regPhone.test(contact_number.value)) {
        document.getElementById('phone_error_bpage').textContent = "Invalid Phone Number.";
        contact_number.focus();
        form.validator = false;
    }
    if (!Boolean(recaptcha)) {
        document.getElementById('recaptcha_error_bpage').textContent = "You can't proceed! Please solve recaptcha";
        form.validator = false;
    }
    else {
        grecaptcha.reset();
    }
    return form;
}

function getPhonecodeOptionValues(id_value) {
    $.ajax({
        async: true,
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "/api/country/GetAllSupported",
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {
            if (Boolean(result)) {
                // if (Boolean(result.success)) {
                var parent_element = document.getElementById(id_value);

                if (result.length > 0) {
                    for (let phonecode of result) {
                        var option_childElement = document.createElement('option');
                        option_childElement.setAttribute("value", "+" + phonecode.phone_code);
                        // option_childElement.setAttribute("disabled", true);
                        // option_childElement.className = "pricing-coption";
                        option_childElement.textContent = phonecode.acronym + "(" + "+" + phonecode.phone_code + ")";
                        parent_element.appendChild(option_childElement);
                    }
                }
                var defaultCountry = localStorage.getItem("Country_Dropdown_New");
                const countryMappings = {
                    "India": "India",
                    "USA": "United States",
                    "UK": "United Kingdom"
                };
                if (defaultCountry in countryMappings) {
                    // Find the index using the mapped country name
                    const mappedCountryName = countryMappings[defaultCountry];
                    const selectIndex = result.findIndex(item => item.country_name === mappedCountryName);
                    // Set the selectedIndex to the found index
                    parent_element.selectedIndex = selectIndex;
                }
                else {
                    var defaultOption = document.createElement('option');
                    defaultOption.textContent = "Country Code";
                    defaultOption.setAttribute("value", "");
                    defaultOption.disabled = true;
                    parent_element.insertBefore(defaultOption, parent_element.firstChild);
                    parent_element.selectedIndex = 0;
                }
                // }
                // else if (!Boolean(result.success)) {

                // }
            }
            else if (!Boolean(result)) {

            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });

}


// function setDefaultCountrySelection() {
//     var defaultCountry = localStorage.getItem("Country_Dropdown_New");
//     console.log(defaultCountry);
//     if (defaultCountry === "India" || defaultCountry === "USA" || defaultCountry === "UK") {
//         var selectElement = document.getElementById('bpage_phone_code');
//         for (var i = 0; i < selectElement.options.length; i++) {
//             console.log(selectElement.options)
//             if (selectElement.options[i].text === defaultCountry) {
//                 selectElement.selectedIndex = i;
//                 break;
//             }
//         }
//     } else {
//         // If the default country is "Other" or some other value, do nothing as it's left for the user to select
//     }
// }
// setDefaultCountrySelection();


function getOncologyData(data) {
    var api_response_error = document.getElementById('form_submit_api_error');
    var api_success_error = document.getElementById('form_submit_api_success');
    var request_body_data = {
        formType: "ONCOLOGY",
        email: data.email,
        name: data.name,
        phone_number: data.final_phone_number,
        recaptcha: data.recaptcha
    }

    $.ajax({
        async: true,
        type: "POST",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/homepage/leadForm/submit",
        headers: {
            'platform': 'web',
        },
        data: JSON.stringify(request_body_data),
        contentType: "application/json",
        success: function (response) {
            if (response.success) {

                api_success_error.textContent = "Form Submitted Successfully!!";
                document.getElementById("Oncologyform").reset();
                // document.getElementById("Oncologyform1").reset();
            }
            else {

                api_response_error.textContent = response.error.message;

            }
        },
        error: function (jqXHR, textStatus, errorThrown) {

            let error_msg = "Something went wrong!";
            if (jqXHR.responseJSON.statusCode == 400) {
                error_msg = jqXHR.responseJSON.message[0];

            }
            api_response_error.textContent = error_msg;
        },
    })
        .done(function (result, textStatus, jqXHR) {

        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
    api_success_error.textContent = "";
    api_response_error.textContent = "";
}

function getLicencingData(data) {
    var apiResponseError = document.getElementById('form_submit_api_error_licencing');
    var apiSuccess = document.getElementById('form_submit_api_success_licencing');
    var requestBodyData = {
        contactNumber: data.final_phone_number,
        recaptcha: data.recaptcha
    }

    $.ajax({
        async: true,
        type: "POST",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/homepage/businessContact",
        headers: {
            'platform': 'web',
        },
        data: JSON.stringify(requestBodyData),
        contentType: "application/json",
        success: function (response) {
            if (response.success) {

                apiSuccess.textContent = "Form Submitted Successfully!!";
                document.getElementById("Licencing_Pageform").reset();
            }
            else {

                apiResponseError.textContent = response.error.message;

            }
        },
        error: function (jqXHR, textStatus, errorThrown) {

            let error_msg = "Something went wrong!";
            if (jqXHR.responseJSON.statusCode == 400) {
                error_msg = jqXHR.responseJSON.message[0];

            }
            apiResponseError.textContent = error_msg;
        },
    })
        .done(function (result, textStatus, jqXHR) {

        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
    apiSuccess.textContent = "";
    apiResponseError.textContent = "";
}

function getBusinessData(data) {
    // var name = document.forms.RegForm.user_name.value;
    // var email = document.forms.RegForm.user_email.value;
    // var phone = document.getElementById('oncology_phone_code').value + document.forms.RegForm.user_phone_number.value;
    // var recaptcha_value = grecaptcha.getResponse();
    var api_response_error = document.getElementById('form_submit_api_error');
    var api_success_error = document.getElementById('form_submit_api_success');
    var request_body_data = {
        formType: "BUSINESS_PAGE",
        email: data.email,
        name: data.name,
        phone_number: data.final_phone_number,
        recaptcha: data.recaptcha
    }

    $.ajax({
        async: true,
        type: "POST",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/homepage/leadForm/submit",
        headers: {
            'platform': 'web',
        },
        data: JSON.stringify(request_body_data),
        contentType: "application/json",
        success: function (response) {
            if (response.success) {

                api_success_error.textContent = "Form Submitted Successfully!!";
                document.getElementById("Buisness_Pageform").reset();
            }
            else {

                api_response_error.textContent = response.error.message;

            }


            // document.forms.RegForm.user_name.value = "";
            // document.forms.RegForm.user_email.value = "";
            // document.forms.RegForm.user_phone_number.value = "";
            // grecaptcha.getResponse() = "";
            // document.getElementById('name_error').textContent = "";
            // document.getElementById('email_error').textContent = "";
            // document.getElementById('phone_error').textContent = "";


        },
        error: function (jqXHR, textStatus, errorThrown) {

            let error_msg = "Something went wrong!";
            if (jqXHR.responseJSON.statusCode == 400) {
                error_msg = jqXHR.responseJSON.message[0];

            }
            api_response_error.textContent = error_msg;


        },
    })
        .done(function (result, textStatus, jqXHR) {
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
    api_success_error.textContent = "";
    api_response_error.textContent = "";
}


function getBuisnessPageData(data) {
    // var name = document.forms.RegForm.user_name.value;
    // var email = document.forms.RegForm.user_email.value;
    // var phone = document.getElementById('oncology_phone_code').value + document.forms.RegForm.user_phone_number.value;
    // var recaptcha_value = grecaptcha.getResponse();
    var api_response_error = document.getElementById('form_submit_api_error_bpage');
    var api_success_error = document.getElementById('form_submit_api_success_bpage');
    var request_body_data = {
        contact_email: data.contact_email,
        name: data.name,
        organization_name: data.organization_name,
        query: data.query,
        contact_number: data.final_phone_number,
        recaptcha: data.recaptcha
    }

    $.ajax({
        async: true,
        type: "POST",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/homepage/user/business/request/form/callback",
        headers: {
            'platform': 'web',
        },
        data: JSON.stringify(request_body_data),
        contentType: "application/json",
        success: function (response) {
            if (response.success) {

                api_success_error.textContent = "Form Submitted Successfully!!";
                document.getElementById("BuisnessPageform").reset();
            }
            else {

                api_response_error.textContent = response.error.message;

            }


            // document.forms.RegForm.user_name.value = "";
            // document.forms.RegForm.user_email.value = "";
            // document.forms.RegForm.user_phone_number.value = "";
            // grecaptcha.getResponse() = "";
            // document.getElementById('name_error').textContent = "";
            // document.getElementById('email_error').textContent = "";
            // document.getElementById('phone_error').textContent = "";


        },
        error: function (jqXHR, textStatus, errorThrown) {

            let error_msg = "Something went wrong!";
            if (jqXHR.responseJSON.statusCode == 400) {
                error_msg = jqXHR.responseJSON.message[0];

            }
            api_response_error.textContent = error_msg;


        },
    })
        .done(function (result, textStatus, jqXHR) {

        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
    api_success_error.textContent = "";
    api_response_error.textContent = "";
}

function formSubmit(token) {
    let form = validator_oncology(token);
    if (form.validator) {
        getOncologyData(form.data);
    }
    else {
        console.log("form invalid");
    }
}


function licencingFormSubmit(token) {
    let form = validatorLicencing();
    if (form.validator) {
        getLicencingData(form.data);
    }
}

function Business_formSubmit(token) {
    let form = validator_businessform(token);
    if (form.validator) {
        getBusinessData(form.data);
    }
    else {
        console.log("form invalid");
    }
}

function validator_businessform(recaptchaToken) {
    var name = document.forms.RegForm1.user_name;
    var email = document.forms.RegForm1.user_email;
    var phone_code = document.forms.RegForm1.oncology_phone_code.value;
    var phone_number = document.forms.RegForm1.user_phone_number;
    var final_phone_number = phone_code.toString() + phone_number.value;
    let data = {
        name: name.value,
        email: email.value,
        phone_code: phone_code.toString(),
        phone_number: phone_number.value,
        final_phone_number: final_phone_number,
        recaptcha: recaptchaToken,
    }

    var regEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var regPhone = /^[0-9-+\s()]{6,16}/;
    var regName = /^[a-zA-Z0-9^\s]+$/;
    let form = {
        validator: true,
        data: data,
    }
    document.getElementById('name_error').textContent = "";
    document.getElementById('email_error').textContent = "";
    document.getElementById('phone_error').textContent = "";
    document.getElementById('form_submit_api_error').textContent = "";
    document.getElementById('form_submit_api_success').textContent = "";
    document.getElementById('recaptcha_error_bcallbackform').textContent = "";
    if (!name.value.trim()) {
        document.getElementById('name_error').textContent = "Please enter name";
        name.focus();
        form.validator = false;
    }
    else if (!regName.test(name.value)) {
        document.getElementById('name_error').textContent = "Invalid name entered";
        name.focus();
        form.validator = false;
    }
    if (!email.value.trim()) {
        document.getElementById('email_error').textContent = "Please enter email";
        email.focus();
        form.validator = false;
    }
    else if (!regEmail.test(email.value)) {
        document.getElementById('email_error').textContent = "Invalid email entered";
        email.focus();
        form.validator = false;
    }
    if (!phone_number.value.trim()) {
        document.getElementById('phone_error').textContent = "Enter Phone Number";
        phone_number.focus();
        form.validator = false;
    }
    else if (!regPhone.test(phone_number.value)) {
        document.getElementById('phone_error').textContent = "Invalid Phone Number.";
        phone_number.focus();
        form.validator = false;
    }
    if (!data.recaptcha.trim()) {
        document.getElementById('recaptcha_error_bcallbackform').textContent = "You can't proceed! Please solve reCAPTCHA";
        form.validator = false;
    }
    else {
        //grecaptcha.reset();
    }
    return form


}


function BusinessformSubmit(token) {
    let form = validator_buisness();
    if (form.validator) {
        getBuisnessPageData(form.data);

    }
    else {
        console.log("form invalid");
    }
}


function getOncologyDoctors() {

    var request_body_data = {
        "specialty_name": ["Oncology"]
    }
    $.ajax({
        async: true,
        type: "POST",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/homepage/doctors/fetchall",
        headers: {
            'platform': 'web',
        },
        data: JSON.stringify(request_body_data),
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('oncology_doctors_div');

                        createDoctorsCards(parentElement, result.data);
                    }
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}

function getAyurvedicDoctors() {

    var request_body_data = {
        "specialty_name": ["Ayurvedic"]
    }
    $.ajax({
        async: true,
        type: "POST",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/homepage/doctors/fetchall",
        headers: {
            'platform': 'web',
        },
        data: JSON.stringify(request_body_data),
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('ayurvedic-doctor-data-div');

                        createDoctorsCards(parentElement, result.data);
                    }
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}

function getFeaturedDoctors() {
    $.ajax({
        async: true,
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/homepage/doctors/fetchall/featured",
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.data.length > 0) {
                        var parentElement = document.getElementById('doctor-data-div');

                        createDoctorsCards(parentElement, result.data.data);
                        show_doctors_init('#doctor-data-div .doctor-item-div', 'doctor');
                        // show_mobile_doctors_init();

                    }
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}

function getFeaturedNutritionists() {
    $.ajax({
        async: true,
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/homepage/nutritionist/fetchall",
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.data.length > 0) {
                        var parentElement = document.getElementById('dietician-data-div');

                        createDoctorsCards(parentElement, result.data.data);
                        show_doctors_init('#dietician-data-div .doctor-item-div', 'nutrition');
                        // show_mobile_doctors_init();

                    }
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}



function getViewAllDoctors() {
    var specialty_id_array = [];
    var country_id_array = [];
    var request_body_data = {
        specialty_id: specialty_id_array,
        country_id: country_id_array
    }
    $.ajax({
        async: true,
        type: "POST",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/doctors/fetchAll/active",
        headers: {
            'platform': 'web',
        },
        data: JSON.stringify(request_body_data),
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('all-doctor-data-div');

                        createDoctorsCards(parentElement, result.data);
                    }
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}

// function getEmailForNotification() {
//     var error = document.getElementById("error_homecare")
//         if (document.getElementById("number").value == " ")
//         {

//             // Changing content and color of content
//             error.textContent = "Please enter an email"
//             error.style.color = "red"
//         } else {
//             error.textContent = ""
//         }

//     var user_email = string;

//     var request_body_data = {
//         email: user_email,
//     }
//     $.ajax({
//         async: true,
//         type: "POST",
//         url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/Homepage/subscription/submit",
//         headers: {
//             'platform': 'web',
//         },
//         data: JSON.stringify(request_body_data),
//         contentType: "application/json",
//         success: function (response) {

//         },
//         error: function (jqXHR, textStatus, errorThrown) {

//         },
//     })
//         .done(function (result, textStatus, jqXHR) {


//             if (Boolean(result)) {
//                 if (Boolean(result.success)) {
//                     if (result.data.length > 0) {
//                         var parentElement = document.getElementById('get-email');


//                     }
//                 }
//                 else if (!Boolean(result.success)) {

//                 }
//             }
//         })
//         .fail(function (jqXHR, textStatus, errorThrown) {

//         })
//         .always(function (jqXHR, textStatus, errorThrown) {

//         });
// }





function openProfile(type, user_guid) {
    var profile_data = {
        'type': type,
        'user_guid': user_guid,
    }
    var profile_data_string = JSON.stringify(profile_data);
    localStorage.setItem("profile_data", profile_data_string);
    // window.open(URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].HOMPAGE_BASE_URL+ "view-profile.html?type=" + type + "&" + "user_guid=" + user_guid, "eGlobalDoctors-View-Profile")
    window.open(URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].HOMPAGE_BASE_URL + "view-profile?type=" + type + "&" + "user_guid=" + user_guid, "eGlobalDoctors-View-Profile")


}

function countDownTimer(timeLeft, elment_id) {
    var timeleft = timeLeft;
    var downloadTimer = setInterval(function () {
        if (timeleft <= 0) {
            clearInterval(downloadTimer);
            // window.open(URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].HOMPAGE_BASE_URL+ "index.html#featured-doctors", "_self");
            // window.open(URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].HOMPAGE_BASE_URL+ "index#featured-doctors", "_self");
            window.open(URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].HOMPAGE_BASE_URL + "#featured-doctors", "_self");
        } else {
            document.getElementById(elment_id).innerHTML = timeleft;
        }
        timeleft -= 1;
    }, 1000)
}

function viewProfile() {
    var praams = new URLSearchParams(window.location.search.substring(1));
    var type = praams.get("type");
    var user_guid = praams.get("user_guid");
    var parent_success_true = document.getElementById("view-profile-success-true")
    var parent_success_false = document.getElementById("view-profile-success-false")
    var timeLeft = 5;
    if (!Boolean(type) || !Boolean(user_guid)) {
        // window.open(URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].HOMPAGE_BASE_URL+ "index.html#featured-doctors","_self");
        parent_success_true.className = "d-none";
        parent_success_false.className = "d-flex";

        var h3_childElement = document.createElement("h3");
        h3_childElement.textContent = "Invalid Link";

        var h5_childElement = document.createElement("h5");
        h5_childElement.textContent = "You will be redirected to the home page in";

        var div_childElement = document.createElement("div");
        div_childElement.id = "view-profile-success-false-countdown";
        div_childElement.textContent = timeLeft;

        h5_childElement.appendChild(div_childElement);

        parent_success_false.appendChild(h3_childElement);
        parent_success_false.appendChild(h5_childElement);
        this.countDownTimer(timeLeft, "view-profile-success-false-countdown");
    }
    else if (Boolean(type) && Boolean(user_guid)) {
        parent_success_true.className = "d-flex";
        parent_success_false.className = "d-none";


        $.ajax({
            async: true,
            type: "GET",
            url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/homepage/doctors/fetch/profile/" + user_guid,
            headers: {
                'platform': 'web',
            },
            contentType: "application/json",
            success: function (response) {

            },
            error: function (jqXHR, textStatus, errorThrown) {

            },
        })
            .done(function (result, textStatus, jqXHR) {

                if (Boolean(result)) {
                    if (Boolean(result.success)) {
                        if (Boolean(result.data)) {
                            var parentElement = document.getElementById('view-profile-success-true');
                            if (result.data.data.role_id == 6) {

                                var c_doc_url = "./assets/images/defaults/default_doc_profile.jpg";
                                if (Boolean(result.data.data.avatar_url)) {
                                    c_doc_url = result.data.data.avatar_url;
                                }

                                var div_mainchildelement = document.createElement("div");
                                div_mainchildelement.className = "main_div";
                                var div_childElement = document.createElement("div");
                                div_childElement.className = "row";
                                var div1_childElement = document.createElement("div");
                                div1_childElement.className = "col-lg-3 mr-0";
                                var div2_childElement = document.createElement("div");
                                div2_childElement.className = "col-lg-9 mt-4";

                                var img_childElement = document.createElement('img');
                                img_childElement.setAttribute("loading", "lazy");
                                img_childElement.setAttribute("data-src", DOMPurify.sanitize(c_doc_url));
                                img_childElement.setAttribute("alt", DOMPurify.sanitize(result.data.data.first_name + " " + result.data.data.last_name + " - " + result.data.data.d_specialty_type.specialty_name));
                                img_childElement.className = "lazyload img-fluid";

                                var h5_1_childElement = document.createElement("p");
                                h5_1_childElement.className = "heading3";
                                h5_1_childElement.textContent = result.data.data.first_name + " " + result.data.data.last_name;

                                var h5_2_childElement = document.createElement("p");
                                h5_2_childElement.className = "heading4 mt-4";
                                h5_2_childElement.textContent = result.data.data.d_specialty_type.specialty_name;

                                var h5_3_childElement = document.createElement("p");
                                h5_3_childElement.className = "heading4";
                                h5_3_childElement.textContent = result.data.data.state_name + ", " + result.data.data.country.country_name;

                                div1_childElement.appendChild(img_childElement);
                                div_childElement.appendChild(div1_childElement);

                                div2_childElement.appendChild(h5_1_childElement);
                                if (Boolean(result.data.data.other_medical_profile.years_of_experience)) {
                                    var h5_4_childElement = document.createElement("p");
                                    h5_4_childElement.className = "heading3";
                                    h5_4_childElement.textContent = "Experience:" + " " + result.data.data.other_medical_profile.years_of_experience + " " + "years"
                                    div2_childElement.appendChild(h5_4_childElement);
                                }
                                div2_childElement.appendChild(h5_2_childElement);
                                div2_childElement.appendChild(h5_3_childElement);
                                div_childElement.appendChild(div2_childElement);

                                div_mainchildelement.appendChild(div_childElement);

                                var div_row2_childElement = document.createElement("div");
                                div_row2_childElement.className = "row mt-4";
                                var hr_1_childelement = document.createElement("hr");
                                div_row2_childElement.appendChild(hr_1_childelement);
                                var div_col1_childElement = document.createElement("div");
                                div_col1_childElement.className = "col-md-6 col-sm-12";
                                if (Boolean(result.data.data.other_medical_profile.education) && result.data.data.other_medical_profile.education.length > 0) {
                                    var heading_name = "Medical School:";
                                    var data = result.data.data.other_medical_profile.education;
                                    var div_medschool_childElement = document.createElement("div");
                                    div_medschool_childElement.className = "medschool_class";
                                    var p_medschool_childElement = document.createElement("h3");
                                    p_medschool_childElement.className = "egd-color heading5";
                                    p_medschool_childElement.textContent = heading_name;

                                    var ul_childElement = document.createElement('ul');
                                    ul_childElement.className = "list-group list-group-flush list-style-profile";
                                    for (let index = 0; index < data.length; index++) {
                                        var li_childElement = document.createElement('li');
                                        li_childElement.className = "white-space-pre-line";
                                        li_childElement.textContent = DOMPurify.sanitize(data[index].name + " : " + data[index].year);
                                        ul_childElement.appendChild(li_childElement);
                                    }

                                    div_medschool_childElement.appendChild(p_medschool_childElement);
                                    div_medschool_childElement.appendChild(ul_childElement);
                                    div_col1_childElement.appendChild(div_medschool_childElement);
                                }


                                if (Boolean(result.data.data.other_medical_profile.certifications) && result.data.data.other_medical_profile.certifications.length > 0) {
                                    var heading_name = "Board Certifications:";
                                    var data = result.data.data.other_medical_profile.certifications;
                                    var div_boardcertifications_childElement = document.createElement("div");
                                    div_boardcertifications_childElement.className = "boardcerti_class mt-md-3";
                                    var p_boardcertifications_childElement = document.createElement("h3");
                                    p_boardcertifications_childElement.className = "egd-color heading5";
                                    p_boardcertifications_childElement.textContent = heading_name;

                                    var ul_childElement = document.createElement('ul');
                                    ul_childElement.className = "list-group list-group-flush list-style-profile";
                                    for (let index = 0; index < data.length; index++) {
                                        var li_childElement = document.createElement('li');
                                        li_childElement.className = "white-space-pre-line";
                                        li_childElement.textContent = DOMPurify.sanitize(data[index]);
                                        ul_childElement.appendChild(li_childElement);
                                    }

                                    div_boardcertifications_childElement.appendChild(p_boardcertifications_childElement);
                                    div_boardcertifications_childElement.appendChild(ul_childElement);
                                    div_col1_childElement.appendChild(div_boardcertifications_childElement);
                                }

                                var div_col2_childElement = document.createElement("div");
                                div_col2_childElement.className = "col-md-6 col-sm-12";
                                if (Boolean(result.data.data.languages) && result.data.data.languages.length > 0) {
                                    var heading_name = "Languages Spoken:";
                                    var data = result.data.data.languages;
                                    var div_language_childElement = document.createElement("div");
                                    div_language_childElement.className = "language_class";
                                    var p_language_childElement = document.createElement("h3");
                                    p_language_childElement.className = "egd-color heading5";
                                    p_language_childElement.textContent = heading_name;

                                    var p_language1_childElement = document.createElement("p");
                                    p_language1_childElement.className = "heading5";
                                    data_list = data.map((ele) => {
                                        return ele.language_name + " (" + ele.english_name + ")";
                                    });
                                    p_language1_childElement.textContent = DOMPurify.sanitize(data_list.join(","));

                                    div_language_childElement.appendChild(p_language_childElement);
                                    div_language_childElement.appendChild(p_language1_childElement);
                                    div_col2_childElement.appendChild(div_language_childElement);
                                }

                                div_row2_childElement.appendChild(div_col1_childElement);
                                div_row2_childElement.appendChild(div_col2_childElement);

                                div_mainchildelement.appendChild(div_row2_childElement);

                                var div_row3_childElement = document.createElement("div");
                                div_row3_childElement.className = "mainbiodiv";
                                var hr_2_childelement = document.createElement("hr");
                                div_row3_childElement.appendChild(hr_2_childelement);
                                if (Boolean(result.data.data.other_medical_profile.description) && result.data.data.other_medical_profile.description.length > 0) {
                                    var heading_name = "Bio:";
                                    var data = result.data.data.other_medical_profile.description;
                                    var div_bio_childElement = document.createElement("div");
                                    div_bio_childElement.className = "specaility_class";
                                    var p_bio_childElement = document.createElement("h3");
                                    p_bio_childElement.className = "egd-color heading5";
                                    p_bio_childElement.textContent = heading_name;

                                    var p_bio1_childElement = document.createElement("p");
                                    p_bio1_childElement.className = "heading5";
                                    p_bio1_childElement.textContent = DOMPurify.sanitize(data);

                                    div_bio_childElement.appendChild(p_bio_childElement);
                                    div_bio_childElement.appendChild(p_bio1_childElement);
                                    div_row3_childElement.appendChild(div_bio_childElement);

                                }
                                var hr_3_childelement = document.createElement("hr");
                                div_row3_childElement.appendChild(hr_3_childelement);
                                div_mainchildelement.appendChild(div_row3_childElement);

                                var div_row4_childElement = document.createElement("div");
                                div_row4_childElement.className = "btndiv text-center";
                                var biobtn_childElement = document.createElement("button");

                                biobtn_childElement.className = "btn btn-outline-primary heading4 egd-color";
                                biobtn_childElement.setAttribute("type", "button");
                                biobtn_childElement.setAttribute("aria-expanded", "false");
                                biobtn_childElement.setAttribute("aria-controls", "collapseExample");
                                biobtn_childElement.textContent = "Book Appointment";
                                biobtn_childElement.setAttribute("onclick", "openWebsiteLinks('PORTAL_BASE_URL','user/login/patient','_blank')");
                                div_row4_childElement.appendChild(biobtn_childElement);
                                div_mainchildelement.appendChild(div_row4_childElement);
                                parentElement.appendChild(div_mainchildelement);
                            }
                            else {
                                var c_doc_url = "./assets/images/defaults/default_doc_profile.jpg";
                                if (Boolean(result.data.data.avatar_url)) {
                                    c_doc_url = result.data.data.avatar_url;
                                }
                                var div_mainchildelement = document.createElement("div");
                                div_mainchildelement.className = "main_div";
                                var div_childElement = document.createElement("div");
                                div_childElement.className = "row";
                                var div1_childElement = document.createElement("div");
                                div1_childElement.className = "col-lg-3 mr-0";
                                var div2_childElement = document.createElement("div");
                                div2_childElement.className = "col-lg-9 mt-4";

                                var img_childElement = document.createElement('img');
                                img_childElement.setAttribute("loading", "lazy");
                                img_childElement.setAttribute("data-src", DOMPurify.sanitize(c_doc_url));
                                img_childElement.setAttribute("alt", DOMPurify.sanitize(result.data.data.first_name + " " + result.data.data.last_name + " - " + result.data.data.d_specialty_type.specialty_name));
                                img_childElement.className = "lazyload img-fluid";

                                var h5_1_childElement = document.createElement("p");
                                h5_1_childElement.className = "heading3";
                                h5_1_childElement.textContent = toTitleCase(result.data.data.doctor_profile.salutation) + " " + result.data.data.first_name + " " + result.data.data.last_name + " ," + result.data.data.doctor_profile.degree;

                                var h5_2_childElement = document.createElement("p");
                                h5_2_childElement.className = "heading4 mt-4";
                                h5_2_childElement.textContent = result.data.data.d_specialty_type.specialty_name;

                                var h5_3_childElement = document.createElement("p");
                                h5_3_childElement.className = "heading4";
                                h5_3_childElement.textContent = result.data.data.state_name + ", " + result.data.data.country.country_name;

                                div1_childElement.appendChild(img_childElement);
                                div_childElement.appendChild(div1_childElement);

                                div2_childElement.appendChild(h5_1_childElement);
                                if (Boolean(result.data.data.doctor_profile.years_experience)) {
                                    var h5_4_childElement = document.createElement("p");
                                    h5_4_childElement.className = "heading3";
                                    h5_4_childElement.textContent = "Experience:" + " " + result.data.data.doctor_profile.years_experience + " " + "years"
                                    div2_childElement.appendChild(h5_4_childElement);
                                }
                                div2_childElement.appendChild(h5_2_childElement);
                                div2_childElement.appendChild(h5_3_childElement);
                                div_childElement.appendChild(div2_childElement);

                                div_mainchildelement.appendChild(div_childElement);

                                var div_row2_childElement = document.createElement("div");
                                div_row2_childElement.className = "row mt-4";
                                var hr_1_childelement = document.createElement("hr");
                                div_row2_childElement.appendChild(hr_1_childelement);
                                var div_col1_childElement = document.createElement("div");
                                div_col1_childElement.className = "col-md-6 col-sm-12";
                                if (Boolean(result.data.data.doctor_profile.education.medical_school) && result.data.data.doctor_profile.education.medical_school.length > 0) {
                                    var heading_name = "Medical School:";
                                    var data = result.data.data.doctor_profile.education.medical_school;
                                    var div_medschool_childElement = document.createElement("div");
                                    div_medschool_childElement.className = "medschool_class";
                                    var p_medschool_childElement = document.createElement("h3");
                                    p_medschool_childElement.className = "egd-color heading5";
                                    p_medschool_childElement.textContent = heading_name;

                                    var ul_childElement = document.createElement('ul');
                                    ul_childElement.className = "list-group list-group-flush list-style-profile";
                                    for (let index = 0; index < data.length; index++) {
                                        var li_childElement = document.createElement('li');
                                        li_childElement.className = "white-space-pre-line";
                                        li_childElement.textContent = DOMPurify.sanitize(data[index].name + " : " + data[index].year);
                                        ul_childElement.appendChild(li_childElement);
                                    }

                                    div_medschool_childElement.appendChild(p_medschool_childElement);
                                    div_medschool_childElement.appendChild(ul_childElement);
                                    div_col1_childElement.appendChild(div_medschool_childElement);
                                }

                                if (Boolean(result.data.data.doctor_profile.education.fellowship) && result.data.data.doctor_profile.education.fellowship.length > 0) {
                                    var heading_name = "Fellowship:";
                                    var data = result.data.data.doctor_profile.education.fellowship;
                                    var div_fellowship_childElement = document.createElement("div");
                                    div_fellowship_childElement.className = "fellowship_class mt-md-3";
                                    var p_fellowship_childElement = document.createElement("h3");
                                    p_fellowship_childElement.className = "egd-color heading5";
                                    p_fellowship_childElement.textContent = heading_name;

                                    var ul_childElement = document.createElement('ul');
                                    ul_childElement.className = "list-group list-group-flush list-style-profile";
                                    for (let index = 0; index < data.length; index++) {
                                        var li_childElement = document.createElement('li');
                                        li_childElement.className = "white-space-pre-line";
                                        li_childElement.textContent = DOMPurify.sanitize(data[index].name + " : " + data[index].year);
                                        ul_childElement.appendChild(li_childElement);
                                    }

                                    div_fellowship_childElement.appendChild(p_fellowship_childElement);
                                    div_fellowship_childElement.appendChild(ul_childElement);
                                    div_col1_childElement.appendChild(div_fellowship_childElement);
                                }

                                if (Boolean(result.data.data.doctor_profile.board_certification) && result.data.data.doctor_profile.board_certification.length > 0) {
                                    var heading_name = "Board Certifications:";
                                    var data = result.data.data.doctor_profile.board_certification;
                                    var div_boardcertifications_childElement = document.createElement("div");
                                    div_boardcertifications_childElement.className = "boardcerti_class mt-md-3";
                                    var p_boardcertifications_childElement = document.createElement("h3");
                                    p_boardcertifications_childElement.className = "egd-color heading5";
                                    p_boardcertifications_childElement.textContent = heading_name;

                                    var ul_childElement = document.createElement('ul');
                                    ul_childElement.className = "list-group list-group-flush list-style-profile";
                                    for (let index = 0; index < data.length; index++) {
                                        var li_childElement = document.createElement('li');
                                        li_childElement.className = "white-space-pre-line";
                                        li_childElement.textContent = DOMPurify.sanitize(data[index]);
                                        ul_childElement.appendChild(li_childElement);
                                    }

                                    div_boardcertifications_childElement.appendChild(p_boardcertifications_childElement);
                                    div_boardcertifications_childElement.appendChild(ul_childElement);
                                    div_col1_childElement.appendChild(div_boardcertifications_childElement);
                                }

                                var div_col2_childElement = document.createElement("div");
                                div_col2_childElement.className = "col-md-6 col-sm-12";
                                if (Boolean(result.data.data.doctor_profile.secondary_speciality) && result.data.data.doctor_profile.secondary_speciality.length > 0) {
                                    var data = result.data.data.doctor_profile.secondary_speciality;
                                    var heading_name = "Subspecialties:";
                                    var div_apecialility_childElement = document.createElement("div");
                                    div_apecialility_childElement.className = "specaility_class";
                                    var p_speciality_childElement = document.createElement("h3");
                                    p_speciality_childElement.className = "egd-color heading5";
                                    p_speciality_childElement.textContent = heading_name;

                                    var p_speciality1_childElement = document.createElement("p");
                                    p_speciality1_childElement.className = "heading5";
                                    p_speciality1_childElement.textContent = DOMPurify.sanitize(data.join(","));

                                    div_apecialility_childElement.appendChild(p_speciality_childElement);
                                    div_apecialility_childElement.appendChild(p_speciality1_childElement);
                                    div_col2_childElement.appendChild(div_apecialility_childElement);

                                }
                                if (Boolean(result.data.data.languages) && result.data.data.languages.length > 0) {
                                    var heading_name = "Languages Spoken:";
                                    var data = result.data.data.languages;
                                    var div_language_childElement = document.createElement("div");
                                    div_language_childElement.className = "language_class";
                                    var p_language_childElement = document.createElement("h3");
                                    p_language_childElement.className = "egd-color heading5";
                                    p_language_childElement.textContent = heading_name;

                                    var p_language1_childElement = document.createElement("p");
                                    p_language1_childElement.className = "heading5";
                                    data_list = data.map((ele) => {
                                        return ele.language_name + " (" + ele.english_name + ")";
                                    });
                                    p_language1_childElement.textContent = DOMPurify.sanitize(data_list.join(","));

                                    div_language_childElement.appendChild(p_language_childElement);
                                    div_language_childElement.appendChild(p_language1_childElement);
                                    div_col2_childElement.appendChild(div_language_childElement);
                                }

                                div_row2_childElement.appendChild(div_col1_childElement);
                                div_row2_childElement.appendChild(div_col2_childElement);

                                div_mainchildelement.appendChild(div_row2_childElement);

                                var div_row3_childElement = document.createElement("div");
                                div_row3_childElement.className = "mainbiodiv";
                                var hr_2_childelement = document.createElement("hr");
                                div_row3_childElement.appendChild(hr_2_childelement);
                                if (Boolean(result.data.data.doctor_profile.description) && result.data.data.doctor_profile.description.length > 0) {
                                    var heading_name = "Bio:";
                                    var data = result.data.data.doctor_profile.description;
                                    var div_bio_childElement = document.createElement("div");
                                    div_bio_childElement.className = "specaility_class";
                                    var p_bio_childElement = document.createElement("h3");
                                    p_bio_childElement.className = "egd-color heading5";
                                    p_bio_childElement.textContent = heading_name;

                                    var p_bio1_childElement = document.createElement("p");
                                    p_bio1_childElement.className = "heading5";
                                    p_bio1_childElement.textContent = DOMPurify.sanitize(data);

                                    div_bio_childElement.appendChild(p_bio_childElement);
                                    div_bio_childElement.appendChild(p_bio1_childElement);
                                    div_row3_childElement.appendChild(div_bio_childElement);

                                }
                                var hr_3_childelement = document.createElement("hr");
                                div_row3_childElement.appendChild(hr_3_childelement);
                                div_mainchildelement.appendChild(div_row3_childElement);

                                var div_row4_childElement = document.createElement("div");
                                div_row4_childElement.className = "btndiv text-center";
                                var biobtn_childElement = document.createElement("button");

                                biobtn_childElement.className = "btn btn-outline-primary heading4 egd-color";
                                biobtn_childElement.setAttribute("type", "button");
                                biobtn_childElement.setAttribute("aria-expanded", "false");
                                biobtn_childElement.setAttribute("aria-controls", "collapseExample");
                                biobtn_childElement.textContent = "Book Appointment";
                                biobtn_childElement.setAttribute("onclick", "openWebsiteLinks('PORTAL_BASE_URL','user/login/patient','_blank')");
                                div_row4_childElement.appendChild(biobtn_childElement);
                                div_mainchildelement.appendChild(div_row4_childElement);
                                parentElement.appendChild(div_mainchildelement);
                            }
                        }
                    }
                    else if (!Boolean(result.success)) {

                    }
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {

            })
            .always(function (jqXHR, textStatus, errorThrown) {

            });
    }

}

function getViewAllNews() {
    $.ajax({
        type: "GET",
        url: "./assets/data/NEWNEWS.json",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('news-data-div');
                        for (let news of result.data) {

                            var div1_childElement = document.createElement('div');
                            var div2_childElement = document.createElement('div');
                            div2_childElement.className = "row";
                            var div3_childElement = document.createElement('div');
                            div3_childElement.className = "col-sm-12";
                            var div4_childElement = document.createElement('div');
                            div4_childElement.className = "row";
                            var div5_childElement = document.createElement('div');
                            div5_childElement.className = "col-sm-12 col-md-3";
                            var div6_childElement = document.createElement('div');
                            div6_childElement.className = "news-heading";
                            div6_childElement.textContent = news.read_time;
                            var div7_childElement = document.createElement('div');
                            div7_childElement.className = "col-sm-12 col-md-6";
                            var div8_childElement = document.createElement('div');
                            div8_childElement.className = "news-heading";
                            div8_childElement.textContent = news.title;
                            var div9_childElement = document.createElement('div');
                            div9_childElement.className = "col-sm-12 col-md-3";


                            var p1_childElement = document.createElement("p");
                            p1_childElement.className = "news-grey-text";
                            var p2_childElement = document.createElement("p");
                            p2_childElement.className = "news-grey-text";

                            var small1_childElement = document.createElement("small");
                            small1_childElement.className = "text-muted";
                            small1_childElement.textContent = news.date;
                            var small2_childElement = document.createElement("small");
                            small2_childElement.className = "text-muted";
                            small2_childElement.textContent = news.heading;

                            var a_childElement = document.createElement("a");
                            a_childElement.setAttribute("href", DOMPurify.sanitize(news.link));
                            a_childElement.setAttribute("target", "_self");
                            a_childElement.setAttribute("rel", "noopener noreferrer nofollow");
                            a_childElement.className = "news-learn-more";
                            a_childElement.textContent = "Learn More";

                            var hr_childElement = document.createElement("hr");
                            hr_childElement.className = "news-hr";

                            p1_childElement.appendChild(small1_childElement);
                            div5_childElement.appendChild(div6_childElement);
                            div5_childElement.appendChild(p1_childElement);
                            p2_childElement.appendChild(small2_childElement);
                            div7_childElement.appendChild(div8_childElement)
                            div7_childElement.appendChild(p2_childElement);
                            div9_childElement.appendChild(a_childElement);
                            div4_childElement.appendChild(div5_childElement);
                            div4_childElement.appendChild(div7_childElement);
                            div4_childElement.appendChild(div9_childElement);
                            div3_childElement.appendChild(div4_childElement);
                            div2_childElement.appendChild(div3_childElement);
                            div2_childElement.appendChild(div3_childElement);
                            div1_childElement.appendChild(div2_childElement);
                            div1_childElement.appendChild(hr_childElement);

                            parentElement.appendChild(div1_childElement);

                        }

                    }
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}

function getLeadershipData() {
    $.ajax({
        type: "GET",
        url: "./assets/data/leadership.json",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('leadership-data-div');
                        for (let leadership of result.data) {
                            if (Boolean(leadership.featured)) {

                                var div_childElement = document.createElement('div');
                                div_childElement.className = "col-sm-12 col-md-6 col-lg-4 my-3 text-center leadership-item";
                                var img_childElement = document.createElement('img');
                                img_childElement.setAttribute("loading", "lazy");
                                img_childElement.className = "lazyload leadership-image";
                                img_childElement.setAttribute("data-src", DOMPurify.sanitize(leadership.image_url));
                                img_childElement.setAttribute("alt", DOMPurify.sanitize(leadership.alt_name));
                                var h4_childElement = document.createElement('h4');
                                h4_childElement.className = "leadership-name heading3 mt-2 notranslate";
                                h4_childElement.textContent = leadership.firstname + leadership.lastname;
                                var h5_childElement = document.createElement('h5');
                                h5_childElement.className = "leadership-title heading4 text-center white-space-pre-line";
                                h5_childElement.textContent = leadership.title;
                                div_childElement.appendChild(img_childElement);
                                div_childElement.appendChild(h4_childElement);
                                div_childElement.appendChild(h5_childElement);
                                if (Boolean(leadership.e_email) && String(leadership.e_email).length > 0) {
                                    var p_childElement = document.createElement('p');
                                    var a_childElement = document.createElement("a");
                                    a_childElement.setAttribute("href", DOMPurify.sanitize("mailto:" + String(leadership.e_email)));
                                    // a_childElement.setAttribute("target", "_self");
                                    a_childElement.className = "leadership-email";
                                    a_childElement.textContent = leadership.e_email;
                                    p_childElement.appendChild(a_childElement);
                                    div_childElement.appendChild(p_childElement);
                                }

                                parentElement.appendChild(div_childElement);
                            }

                        }

                    }
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}



function getAdvisoryData() {
    $.ajax({
        type: "GET",
        url: "./assets/data/advisory.json",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (result.data.length > 0) {
                        var parentElement = document.getElementById('advisory-data-div');
                        for (let advisory of result.data) {
                            if (Boolean(advisory.featured)) {

                                var div_childElement = document.createElement('div');
                                div_childElement.className = "col-sm-12 col-lg-3 text-center advisory-item my-4";
                                var img_childElement = document.createElement('img');
                                img_childElement.setAttribute("loading", "lazy");
                                img_childElement.className = "lazyload advisory-image img-fluid";
                                img_childElement.setAttribute("data-src", DOMPurify.sanitize(advisory.image_url));
                                img_childElement.setAttribute("alt", DOMPurify.sanitize(advisory.alt_name));
                                var div_childElement1 = document.createElement('div');
                                div_childElement1.className = "col-sm-12 col-lg-9 advisory-text my-4";
                                var h4_childElement = document.createElement('h4');
                                h4_childElement.className = "leadership-name heading3 notranslate";
                                h4_childElement.textContent = advisory.firstname + ' ' + advisory.lastname;
                                var h5_childElement = document.createElement('h5');
                                h5_childElement.className = "leadership-title heading5 justify-content-center white-space-pre-line";
                                h5_childElement.textContent = advisory.longDescription;
                                var hr_childElement = document.createElement('hr');
                                var div_childElement2 = document.createElement('div');
                                div_childElement2.className = "col-sm-12";

                                div_childElement.appendChild(img_childElement);
                                div_childElement1.appendChild(h4_childElement);
                                div_childElement1.appendChild(h5_childElement);
                                div_childElement2.appendChild(hr_childElement);
                                if (Boolean(advisory.e_email) && String(advisory.e_email).length > 0) {
                                    var p_childElement = document.createElement('p');
                                    var a_childElement = document.createElement("a");
                                    a_childElement.setAttribute("href", DOMPurify.sanitize("mailto:" + String(advisory.e_email)));
                                    // a_childElement.setAttribute("target", "_self");
                                    a_childElement.className = "leadership-email";
                                    a_childElement.textContent = advisory.e_email;
                                    p_childElement.appendChild(a_childElement);
                                    div_childElement.appendChild(p_childElement);
                                }

                                parentElement.appendChild(div_childElement);
                                parentElement.appendChild(div_childElement1);
                                parentElement.appendChild(div_childElement2);
                            }

                        }

                    }
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}



// function getNutritionistData() {
//     $.ajax({
//         type: "GET",
//         url: "./assets/data/dieticians.json",
//         contentType: "application/json",
//         success: function (response) {

//         },
//         error: function (jqXHR, textStatus, errorThrown) {

//         },
//     })
//         .done(function (result, textStatus, jqXHR) {

//             if (Boolean(result)) {
//                 if (Boolean(result.success)) {
//                     if (result.data.length > 0) {
//                         var parentElement = document.getElementById('dietician-data-div');
//                         for (let dietician of result.data) {


//                             var div_childElement = document.createElement('div');
//                             div_childElement.className = "col-6 col-lg-3 mb-4";

//                             var img_childElement = document.createElement('img');
//                             img_childElement.setAttribute("loading", "lazy");
//                             img_childElement.setAttribute("data-src", DOMPurify.sanitize(ASSETS_CONTAINER_LINK + dietician.imgsrc));
//                             img_childElement.setAttribute("alt", dietician.imgalt);
//                             img_childElement.className = "lazyload doctor-card-img";

//                             var p1_childElement = document.createElement("p");
//                             p1_childElement.className = "heading4 mx-5 mt-2 font-weight-600";
//                             p1_childElement.textContent = dietician.name;

//                             var button_childElement = document.createElement("button");
//                             button_childElement.setAttribute("type", "button");
//                             button_childElement.setAttribute("onclick", "openProfile(" + "'doctor'" + "," + "'" + doctor.user_guid + "'" + ");");
//                             button_childElement.className = "mt-auto mx-auto d-block d-md-none btn btn-default btn-primary banner-get-started-button width-max-content";
//                             button_childElement.textContent = "View Profile";

//                             var span2_childElement = document.createElement("span");
//                             span2_childElement.className = "banner-get-started-label";
//                             span2_childElement.textContent = "View Profile";





//                             div_childElement.appendChild(img_childElement);
//                             div_childElement.appendChild(p1_childElement);
//                             div_childElement.appendChild(button_childElement);


//                             parentElement.appendChild(div_childElement);



//                         }

//                     }
//                 }
//                 else if (!Boolean(result.success)) {

//                 }
//             }
//         })
//         .fail(function (jqXHR, textStatus, errorThrown) {

//         })
//         .always(function (jqXHR, textStatus, errorThrown) {

//         });
// }








function getYoutubeLinks() {
    $.ajax({
        type: "GET",
        url: "./assets/data/languages.json",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    // var parentElement = document.getElementById("languages-youtube-data-div");
                    // parentElement.setAttribute("data-src", "https://www.youtube.com/embed/iD4aYeMqnK4?rel=0&modestbranding=1&autohide=1&showinfo=0&controls=0");
                    var id_name = "languages-youtube-data-div";
                    if (result.data.length > 0) {
                        document.querySelectorAll('[id=languages-button-data-div]').forEach(element => {
                            create_youtube_button_data(id_name, element, result.data);
                        });
                    }
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });

}


function create_youtube_button_data(id_name, element, buttons_data) {

    var parentElement = element;
    for (let buttons of buttons_data) {
        // <button type="button" class="btn btn-info mb-3 ml-2 banner-get-started-button"
        //                  onclick = "setYoutubeLink(lang)" > buttons</button >

        var button_childElement = document.createElement('button');
        button_childElement.className = "btn btn-info mb-3 ml-2 banner-get-started-button";
        button_childElement.setAttribute("type", "button");
        button_childElement.textContent = buttons.name;
        var current_yt_link = DOMPurify.sanitize(buttons.link);
        button_childElement.setAttribute("onclick", "setYoutubeLink(" + "'" + id_name + "'" + "," + "'" + current_yt_link + "'" + ");");

        parentElement.appendChild(button_childElement);

    }
}

function getPrivacyPolicyData() {
    $.ajax({
        async: true,
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/terms/Get/3",
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {

                    var parentElement = document.getElementById('privacy-policy-data-div');
                    var html_code = DOMPurify.sanitize(result.data.terms_data);
                    parentElement.innerHTML = html_code;

                }
                else if (!Boolean(result.success)) {
                    //error handling
                }
            }

        })
        .fail(function (jqXHR, textStatus, errorThrown) {


        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}

function getTermsOfUseData() {

    $.ajax({
        async: true,
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/terms/Get/2",
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {

                    var parentElement = document.getElementById('terms-of-use-data-div');
                    var html_code = DOMPurify.sanitize(result.data.terms_data);
                    parentElement.innerHTML = html_code;

                }
                else if (!Boolean(result.success)) {
                    //error handling
                }
            }

        })
        .fail(function (jqXHR, textStatus, errorThrown) {


        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}

function getTermsAndConditionsData() {

    $.ajax({
        async: true,
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/terms/Get/3",
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {

                    var parentElement = document.getElementById('terms-and-conditions-data-div');
                    var html_code = DOMPurify.sanitize(result.data.terms_data);
                    parentElement.innerHTML = html_code;

                }
                else if (!Boolean(result.success)) {
                    //error handling
                }
            }

        })
        .fail(function (jqXHR, textStatus, errorThrown) {


        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}

function getDoctorYoutubeLinks() {
    $.ajax({
        type: "GET",
        url: "./assets/data/doctorvideo.json",
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    // var parentElement = document.getElementById("languages-youtube-data-div");
                    // parentElement.setAttribute("data-src", "https://www.youtube.com/embed/iD4aYeMqnK4?rel=0&modestbranding=1&autohide=1&showinfo=0&controls=0");
                    var id_name = "doctorvideos-youtube-data-div";
                    if (result.data.length > 0) {
                        document.querySelectorAll('[id=doctorvideos-button-data-div]').forEach(element => {
                            create_youtube_button_data(id_name, element, result.data);
                        });
                    }
                }
                else if (!Boolean(result.success)) {

                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });

}

function getEquipmentSupportTimingsandZoomLink() {
    $.ajax({
        async: true,
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/zoom/stryker/equipmentsupport/fetch",
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(SHOW_EQUIPMENT_TECHNICAL_SUPPORT_TIMINGS)) {
                if (Boolean(result)) {
                    if (Boolean(result.success)) {

                        var parentElement = document.getElementById('equip-tech-timings');
                        if (Boolean(result.data.timings)) {
                            if (result.data.timings.length > 0) {
                                // timings = result.data.timings;
                                for (let [index, timings] of result.data.timings.entries()) {
                                    var div_childElement = document.createElement('div');
                                    div_childElement.className = "col-sm-12 col-lg-6 mt-1 border-2px-solid-black";
                                    var p_childElement = document.createElement('p');
                                    p_childElement.className = "text-center egd-theme-text font-weight-bold mt-3 heading4";
                                    if (index == 0) {
                                        p_childElement.textContent = "Weekdays";
                                    }
                                    if (index == 1) {
                                        p_childElement.textContent = "Weekends";
                                    }
                                    var p1_childElement = document.createElement('p');
                                    p1_childElement.className = "text-center heading4";
                                    p1_childElement.textContent = timings[0][0] + " - " + timings[0][1] + " IST";

                                    var p2_childElement = document.createElement('p');
                                    p2_childElement.className = "text-center";
                                    p2_childElement.textContent = timings[1][0] + " - " + timings[1][1] + " IST";

                                    div_childElement.appendChild(p_childElement);
                                    div_childElement.appendChild(p1_childElement);
                                    div_childElement.appendChild(p2_childElement);
                                    parentElement.appendChild(div_childElement);
                                }

                            }

                        }
                        if (Boolean(result.data.link)) {
                            document.getElementById("equip-tech-zoom-link").setAttribute("onclick", "open_link(" + "'" + result.data.link + "'" + "," + "'_self'" + ");");
                        }

                    }
                    else if (!Boolean(result.success)) {
                        //error handling
                    }
                }
            }
            else if (!Boolean(SHOW_EQUIPMENT_TECHNICAL_SUPPORT_TIMINGS)) {

                var parentElement = document.getElementById('equip-tech-timings');

                for (let index = 0; index < 2; index++) {
                    var div_childElement = document.createElement('div');
                    div_childElement.className = "col-sm-12 col-lg-6 mt-1 border-2px-solid-black";
                    var p_childElement = document.createElement('p');
                    p_childElement.className = "text-center egd-theme-text font-weight-bold mt-3";
                    if (index == 0) {
                        p_childElement.textContent = "Weekdays";
                    }
                    if (index == 1) {
                        p_childElement.textContent = "Weekends";
                    }
                    var p1_childElement = document.createElement('p');
                    p1_childElement.className = "text-center";
                    p1_childElement.textContent = "TBD";

                    // var p2_childElement = document.createElement('p');
                    // p2_childElement.className = "text-center";
                    // p2_childElement.textContent = " TBD";

                    div_childElement.appendChild(p_childElement);
                    div_childElement.appendChild(p1_childElement);
                    // div_childElement.appendChild(p2_childElement);
                    parentElement.appendChild(div_childElement);
                }

                if (Boolean(result.data.link)) {
                    document.getElementById("equip-tech-zoom-link").setAttribute("onclick", "open_link(" + "'" + result.data.link + "'" + "," + "'_self'" + ");");
                }

                else if (!Boolean(result.success)) {
                    //error handling
                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {


        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });

}

function setEquipmentSupportLinks() {
    document.getElementById("equip-tech-reg-form").setAttribute("onclick", "open_link(" + "'" + TECHNICAL_SUPPORT_REQUESTOR_FORM + "'" + "," + "'_self'" + ");");
    // document.getElementById("equip-tech-zoom-link").setAttribute("onclick", "open_link(" + ENCOUNTER_FORM + "," + "'_self'" + ");");
    document.getElementById("equip-tech-feedback").setAttribute("onclick", "open_link(" + "'" + TECHNICAL_SUPPORT_REQUESTOR_FEEDBACK_FORM + "'" + "," + "'_self'" + ");");
    // document.getElementById("equip-tech-volunteer-consultant-profile").setAttribute("onclick", "open_link(" + "'" + VOLUNTEER_TECHNICAL_SUPPORT_CONSULTANT_PROFILE + "'" + "," + "'_self'" + ");");
}

function getTechnicalSupportRequesterZoomLink() {
    $.ajax({
        async: true,
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "api/zoom/Get/covid_meeting_link",
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    if (Boolean(result.data.link)) {
                        document.getElementById("equip-tech-zoom-link").setAttribute("onclick", "open_link(" + "'" + result.data.link + "'" + "," + "'_self'" + ");");
                    }

                }
                else if (!Boolean(result.success)) {
                    //error handling
                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {


        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });

}

function setTechnicalSupportRequesterLinks() {
    document.getElementById("equip-tech-reg-form").setAttribute("onclick", "open_link(" + "'" + TECHNICAL_SUPPORT_REQUESTOR_FORM + "'" + "," + "'_self'" + ");");
    // document.getElementById("equip-tech-zoom-link").setAttribute("onclick", "open_link(" + ENCOUNTER_FORM + "," + "'_self'" + ");");
    document.getElementById("equip-tech-feedback").setAttribute("onclick", "open_link(" + "'" + TECHNICAL_SUPPORT_REQUESTOR_FEEDBACK_FORM + "'" + "," + "'_self'" + ");");
    // document.getElementById("equip-tech-volunteer-consultant-profile").setAttribute("onclick", "open_link(" + "'" + VOLUNTEER_TECHNICAL_SUPPORT_CONSULTANT_PROFILE + "'" + "," + "'_self'" + ");");
}

function setTechnicalSupportLinks() {
    document.getElementById("equip-tech-volunteer-registration-form").setAttribute("onclick", "open_link(" + "'" + VOLUNTEER_TECHNICAL_SUPPORT_CONSULTANT_PROFILE + "'" + "," + "'_self'" + ");");
    document.getElementById("equip-tech-support-faq-form").setAttribute("onclick", "open_link(" + "'" + FAQ_AND_SUPPORT + "'" + "," + "'_self'" + ");");
    document.getElementById("equip-encounter-form").setAttribute("onclick", "open_link(" + "'" + ENCOUNTER_FORM + "'" + "," + "'_self'" + ");");
    document.getElementById("equip-technical-adviser-form").setAttribute("onclick", "open_link(" + "'" + VOLUNTEER_TECHNICAL_SUPPORT_CONSULTANT_FEEDBACK_FORM + "'" + "," + "'_self'" + ");");
}

// function openPortalLink(link) {
//     var url_link = DOMPurify.sanitize(PORTAL_BASE_URL + link);

//     window.location.replace(url_link);
// }


function openWebsiteLinks(base_url_name, link, target) {
    let url_link = DOMPurify.sanitize(getBaseUrl(base_url_name) + link)
    if (target == "_self") {
        // window.open(url_link,"_self");
        // window.location.href = url_link;
        window.location.replace(url_link);
        // return false;

    }
    else {
        window.open(url_link, target);
    }

}

function getBaseUrl(base_url_name) {
    return URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX][base_url_name];
}


function open_link(link, target) {
    var sanitized_link = DOMPurify.sanitize(link)
    // window.open(sanitized_link, "_self");
    const a_childElement = document.createElement('a');

    Object.assign(a_childElement, {
        target: target,
        href: sanitized_link,
        rel: "noopener noreferrer nofollow"
    }).click()

}

function viewAllDoctorSearch() {
    var parent_ele = document.getElementById("all-doctor-data-div");
    var doctors_div_list = parent_ele.getElementsByClassName("doctor-item-div");
    var doctors_name_list = parent_ele.getElementsByClassName("doctor-name");
    var doctors_specailty_list = parent_ele.getElementsByClassName("specialty-label");

    var filter_input = document.getElementById("searchNameQuery");
    var filter = filter_input.value.toUpperCase();
    for (let i = 0; i < doctors_name_list.length; i++) {

        var textValue_doctor_name = doctors_name_list[i].textContent || doctors_name_list[i].innerText;
        var textValue_specailty_name = doctors_specailty_list[i].textContent || doctors_specailty_list[i].innerText;
        if ((textValue_doctor_name.toUpperCase().indexOf(filter) > -1) || (textValue_specailty_name.toUpperCase().indexOf(filter) > -1)) {
            doctors_div_list[i].style.display = "unset";
        }
        else {
            doctors_div_list[i].style.display = "none";
        }
    }
}

function viewAllSpecialtySearch() {
    var parent_ele = document.getElementById("all-specialty-data-div");
    var specialty_div_list = parent_ele.getElementsByClassName("specialty-item-div");
    var specialty_name_list = parent_ele.getElementsByClassName("specialty-item-label");

    var filter_input = document.getElementById("searchNameQuery");
    var filter = filter_input.value.toUpperCase();
    for (let i = 0; i < specialty_name_list.length; i++) {

        var textValue = specialty_name_list[i].textContent || specialty_name_list[i].innerText;
        if (textValue.toUpperCase().indexOf(filter) > -1) {
            specialty_div_list[i].style.display = "flex";
        }
        else {
            specialty_div_list[i].style.display = "none";
        }
    }
}

function watchVideo() {
    var parent_element = document.getElementById("why-egd-video");
    if (parent_element.className.split(" ").includes("d-none") &&
        parent_element.className.split(" ").includes("d-sm-block")) {
        var array = parent_element.className.split(" ");
        var index;
        index = array.indexOf("d-none");
        if (index > -1) {
            array.splice(index, 1);
        }
        index = array.indexOf("d-sm-block");
        if (index > -1) {
            array.splice(index, 1);
        }

        parent_element.className = array.join(" ") + " d-block";
    }
    else if (parent_element.className.split(" ").includes("d-block")) {
        var array = parent_element.className.split(" ");
        var index;
        index = array.indexOf("d-block");
        if (index > -1) {
            array.splice(index, 1);
        }

        parent_element.className = array.join(" ") + " d-none d-sm-block";

    }

}

function checkcountry() {
    var currentCountryLocalStorage = localStorage.getItem("Country_Dropdown_New");
    var thursdayOfferings = document.getElementById("thursday-offerings");
    var selectedCountryLabel = localStorage.getItem("Country_Dropdown");
    var phoneByCountry = document.getElementById('phone-by-country');
    var landingtravellingprice = document.getElementById('landingpageprice-usa');
    // if (currentCountryLocalStorage == "UK") {
    //     window.location.href = HOMPAGE_BASE_UK_URL;
    // }
    if (currentCountryLocalStorage == "India") {
        thursdayOfferings.style.display = 'block';
        phoneByCountry.textContent = "+91 207-119-0009";
        phoneByCountry.setAttribute('data-href', 'tel:+91 207-119-0009');
        landingtravellingprice.textContent = "₹10000";
    } else {
        thursdayOfferings.style.display = 'none';
        phoneByCountry.textContent = " +1 213-406-7898";
        phoneByCountry.setAttribute('data-href', 'tel:+1 213-406-7898');
        landingtravellingprice.textContent = "$99";
    }
}

function updateHTML(element_id, property_string_type, value) {
    //property_string_type
    // 0 .innerHTML
    // 1 .style.display
    // 2 .class_name
    let element = document.getElementById(element_id);
    if (typeof element !== 'undefined' && element !== null) {

        if (property_string_type == 0) {
            element.innerHTML = value;
        }
        else if (property_string_type == 1) {
            element.style.display = value;
        }
        else if (property_string_type == 2) {
            element.className = value;
        }
    }
}

function getRenderedAmount(raw_amount, currency_type) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency_type
    }).format(raw_amount);
}

function setCountryData(data) {
    if (data.indiaspecialist == "0" && data.followupspind == "0") {
        updateHTML('primary-indspecialist', 1, 'none');
        updateHTML('primary-indspecialist-banner', 1, 'none');
        updateHTML('followup-indspecialist', 1, 'none');
        updateHTML('ind-speciality', 1, 'none');
        updateHTML('thurday_pricing', 1, 'none');
        updateHTML('thurday_pricing1', 1, 'none');
        updateHTML('primary-internist-ind', 1, 'none');
        updateHTML('ind-speciality-banner', 1, 'none');
        updateHTML('indfollow-speciality', 1, 'none');
        updateHTML('second-indiaspecialist', 1, 'none');
        updateHTML('second-indiaspecialist-banner', 1, 'none');
        updateHTML('ind-spec-sec', 1, 'none');
        updateHTML('ind-spec-sec-banner', 1, 'none');
        updateHTML('multi-indiaspecialist', 1, 'none');
        updateHTML('multi-indiaspecialist-banner', 1, 'none');
        updateHTML('multi-indspl', 1, 'none');
        updateHTML('multi-indspl-banner', 1, 'none');
        updateHTML('packages_india', 1, 'none');
        updateHTML('packages', 1, 'block');
        updateHTML('packages-data-div', 1, 'block');

    }
    else {
        updateHTML('primary-indspecialist', 1, 'block');
        updateHTML('thurday_pricing', 1, 'block');
        updateHTML('thurday_pricing1', 1, 'block');
        updateHTML('packages_india', 1, 'block');
        updateHTML('packages', 1, 'none');
        updateHTML('packages-data-div', 1, 'none');
        updateHTML('primary-internist-ind', 1, 'block');
        updateHTML('primary-indspecialist-banner', 1, 'block');
        updateHTML('followup-indspecialist', 1, 'block');
        updateHTML('ind-speciality', 1, 'block');
        updateHTML('ind-speciality-banner', 1, 'block');
        updateHTML('indfollow-speciality', 1, 'block');
        updateHTML('second-indiaspecialist', 1, 'block');
        updateHTML('second-indiaspecialist-banner', 1, 'block');
        updateHTML('ind-spec-sec', 1, 'block');
        updateHTML('ind-spec-sec-banner', 1, 'block');
        updateHTML('multi-indiaspecialist', 1, 'block');
        updateHTML('multi-indiaspecialist-banner', 1, 'block');
        updateHTML('multi-indspl', 1, 'block');
        updateHTML('multi-indspl-banner', 1, 'block');
        updateHTML('primary-indspecialist', 0, getRenderedAmount(data.indiaspecialist, data.currency_type));
        updateHTML('primary-indspecialist-banner', 0, getRenderedAmount(data.indiaspecialist, data.currency_type));
        updateHTML('followup-indspecialist', 0, getRenderedAmount(data.followupspind, data.currency_type));
        updateHTML('second-indiaspecialist', 0, getRenderedAmount(data.secondindiaspecialist, data.currency_type));
        updateHTML('second-indiaspecialist-banner', 0, getRenderedAmount(data.secondindiaspecialist, data.currency_type));
        updateHTML('multi-indiaspecialist', 0, getRenderedAmount(data.multispecialist, data.currency_type) + " " + "each");
        updateHTML('multi-indiaspecialist-banner', 0, getRenderedAmount(data.multispecialist, data.currency_type) + " " + "each");

    }
    updateHTML('pricing-b-subtitle', 0, "Secured Private Consultation + Video call &#8226; Starts at just" + " " + getRenderedAmount(data.amount, data.currency_type) + " " + data.discount);
    updateHTML('health-card-li-txt-amount', 0, getRenderedAmount(data.healthpassport, data.currency_type) + "/" + " " + "year");

    updateHTML('health-card-li-txt-followup', 0, getRenderedAmount(data.followup, data.currency_type));

    updateHTML('health-card-li-txt-followup-sp', 0, getRenderedAmount(data.followupsp, data.currency_type));

    updateHTML('primary-internist', 0, getRenderedAmount(data.primaryinternist, data.currency_type));
    updateHTML('primary-internist-banner', 0, getRenderedAmount(data.primaryinternist, data.currency_type));

    updateHTML('primary-othspecialist', 0, getRenderedAmount(data.otherspecialist, data.currency_type));
    updateHTML('primary-othspecialist-banner', 0, getRenderedAmount(data.otherspecialist, data.currency_type));

    updateHTML('secondary-specialist', 0, getRenderedAmount(data.secondspecialist, data.currency_type));
    updateHTML('secondary-specialist-banner', 0, getRenderedAmount(data.secondspecialist, data.currency_type));

    updateHTML('multi-specialist', 0, getRenderedAmount(data.multispecialistother, data.currency_type) + " " + "each");
    updateHTML('multi-specialist-banner', 0, getRenderedAmount(data.multispecialistother, data.currency_type) + " " + "each");
    updateHTML('spl', 0, data.specialist);
    updateHTML('spl-banner', 0, data.specialist);
    updateHTML('spl-sec', 0, data.specialist);
    updateHTML('spl-sec-banner', 0, data.specialist);
    updateHTML('spl-mul', 0, data.specialist);
    updateHTML('spl-mul-banner', 0, data.specialist);
    updateHTML('spl-follow', 0, data.specialist);
    if (data.showstrike) {
        updateHTML('primary-internist', 2, 'strikethrough');
        document.getElementById('primary-internist').classList.add('notranslate');

        updateHTML('primary-indspecialist', 2, 'strikethrough');
        document.getElementById('primary-indspecialist').classList.add('notranslate');
        updateHTML('health-card-li-txt-followup', 2, 'strikethrough');
        document.getElementById('health-card-li-txt-followup').classList.add('notranslate');
        updateHTML('followup-indspecialist', 2, 'strikethrough');
        document.getElementById('followup-indspecialist').classList.add('notranslate');
        updateHTML('primary-internist-banner', 2, 'strikethrough');
        updateHTML('primary-indspecialist-banner', 2, 'strikethrough');
        updateHTML('showstriketext6', 1, 'block');
        updateHTML('afterstrikeamount', 1, 'block');
        updateHTML('showstriketext', 1, 'block');
        updateHTML('showstriketext', 0, getRenderedAmount((data.primaryinternist * 90 / 100), data.currency_type) + " " + "(10% off)");
        updateHTML('showstriketext1', 1, 'block');
        updateHTML('showstriketext1', 0, getRenderedAmount((data.indiaspecialist * 90 / 100), data.currency_type) + " " + "(10% off)");
        updateHTML('showstriketext2', 1, 'block');
        updateHTML('showstriketext2', 0, getRenderedAmount((data.followup * 90 / 100), data.currency_type) + " " + "(10% off)");
        updateHTML('showstriketext3', 1, 'block');
        updateHTML('showstriketext3', 0, getRenderedAmount((data.followupspind * 90 / 100), data.currency_type) + " " + "(10% off)");
        updateHTML('showstriketext4', 1, 'block');
        updateHTML('showstriketext4', 0, getRenderedAmount((data.primaryinternist * 90 / 100), data.currency_type) + " " + "(10% off)");
        updateHTML('showstriketext5', 1, 'block');
        updateHTML('showstriketext5', 0, getRenderedAmount((data.indiaspecialist * 90 / 100), data.currency_type) + " " + "(10% off)");

    }
    else {
        updateHTML('primary-internist', 2, 'nostrike');
        updateHTML('primary-indspecialist', 2, 'nostrike');
        updateHTML('health-card-li-txt-followup', 2, 'nostrike');
        updateHTML('followup-indspecialist', 2, 'nostrike');
        updateHTML('primary-internist-banner', 2, 'nostrike');
        updateHTML('primary-indspecialist-banner', 2, 'nostrike');
        updateHTML('showstriketext', 1, 'none');
        updateHTML('showstriketext1', 1, 'none');
        updateHTML('showstriketext2', 1, 'none');
        updateHTML('showstriketext3', 1, 'none');
        updateHTML('showstriketext4', 1, 'none');
        updateHTML('showstriketext5', 1, 'none');
        updateHTML('showstriketext6', 1, 'none');
        updateHTML('afterstrikeamount', 1, 'none');
    }
}

function setPriceCountry() {
    var country = localStorage.getItem("Country_Dropdown_New");
    var primaryStrike1 = document.getElementById("primary-strike-1");
    var primaryMain1 = document.getElementById("primary-main-1");
    var primaryStrike2 = document.getElementById("primary-strike-2");
    var primaryMain2 = document.getElementById("primary-main-2");

    if (!country || country !== 'India') {
        if (primaryStrike1) {
            primaryStrike1.style.display = "none";
        }
        if (primaryMain1) {
            primaryMain1.style.display = "none";
        }
        if (primaryStrike2) {
            primaryStrike2.style.display = "none";
        }
        if (primaryMain2) {
            primaryMain2.style.display = "none";
        }
    }
    else {
        if (primaryStrike1) {
            primaryStrike1.style.display = "inline";
        }
        if (primaryMain1) {
            primaryMain1.style.display = "inline";
        }
        if (primaryStrike2) {
            primaryStrike2.style.display = "inline";
        }
        if (primaryMain2) {
            primaryMain2.style.display = "inline";
        }
    }
}
setPriceCountry()

function setDietCountryData(data) {
    if (data.showdietdata) {
        updateHTML('freediet', 0, getRenderedAmount(data.freediet, data.currency_type));
        updateHTML('threeweek', 0, getRenderedAmount(data.threeweeksdiet, data.currency_type));
        updateHTML('threemon', 0, getRenderedAmount(data.threemonthsdiet, data.currency_type));
        updateHTML('freetxt', 0, "FREE");

    }
    else {
        let default_data = PRICING_DATA_GLOBAL_LIST[0];
        updateHTML('freediet', 0, getRenderedAmount(default_data.freediet, default_data.currency_type));
        updateHTML('threeweek', 0, getRenderedAmount(default_data.threeweeksdiet, default_data.currency_type));
        updateHTML('threemon', 0, getRenderedAmount(default_data.threemonthsdiet, default_data.currency_type));
        updateHTML('freetxt', 0, "FREE");
    }
}

function setCountryDropdownDataViewDoctors() {

    $.ajax({
        async: true,
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + "/api/country/GetAllSupported",
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {
            if (Boolean(result)) {
                // if (Boolean(result.success)) {
                var parent_element = document.getElementById('view-doctors-country-dropdown-options');

                var option_childElement = document.createElement('option');
                option_childElement.setAttribute("value", "");
                option_childElement.setAttribute("disabled", true);
                // option_childElement.className = "pricing-coption";
                option_childElement.textContent = "Select Country";
                parent_element.appendChild(option_childElement);

                var option_childElement = document.createElement('option');
                option_childElement.setAttribute("value", -1);
                // option_childElement.setAttribute("disabled", true);
                // option_childElement.className = "pricing-coption";
                option_childElement.textContent = "ALL";
                parent_element.appendChild(option_childElement);

                if (result.length > 0) {
                    for (let country of result) {
                        var option_childElement = document.createElement('option');
                        option_childElement.setAttribute("value", country.id);
                        // option_childElement.setAttribute("disabled", true);
                        // option_childElement.className = "pricing-coption";
                        option_childElement.textContent = country.country_name;
                        parent_element.appendChild(option_childElement);
                    }
                }
                // }
                // else if (!Boolean(result.success)) {

                // }
            }
            else if (!Boolean(result)) {

            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {

        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });



    document.getElementById('view-doctors-country-dropdown-options').value = "ALL";

}

async function setCountryDropdownDataPricing() {



    /*


    var parent_element = document.getElementById('pricing-dropdown-options');

    var option_childElement = document.createElement('option');
    option_childElement.setAttribute("value", "");
    option_childElement.setAttribute("disabled", true);
    // option_childElement.className = "pricing-coption";
    option_childElement.textContent = "Select Country";
    parent_element.appendChild(option_childElement);

    var countries_list = COUNTRY_DATA_GLOBAL_LIST.slice();

    for (let country of countries_list) {
        var option_childElement = document.createElement('option');
        option_childElement.setAttribute("value", country);
        // option_childElement.setAttribute("disabled", true);
        // option_childElement.className = "pricing-coption";
        option_childElement.textContent = country;
        parent_element.appendChild(option_childElement);
    }

    var option_childElement = document.createElement('option');
    option_childElement.setAttribute("value", "Other");
    // option_childElement.setAttribute("disabled", true);
    // option_childElement.className = "pricing-coption";
    option_childElement.textContent = "Other";
    parent_element.appendChild(option_childElement);

    document.getElementById('pricing-dropdown-options').value = "";
    */
    setMainCountryDropdown('pricing-dropdown-options');
}

function create_element(text_data) {
    var p = document.createElement("p");
    p.textContent = text_data;
    return p;
}

function getCountryIndex(country_name) {
    var countries_list = COUNTRY_DATA_GLOBAL_LIST;
    var selected_index = 0; //default usa
    var selected_country = country_name;

    if (countries_list.includes(selected_country)) {
        selected_index = countries_list.indexOf(selected_country) + 1;
    }
    return selected_index;

}


async function location_pricing() {
    if (Boolean(localStorage.getItem("Country_Dropdown_New"))) {
        var selected_country = localStorage.getItem("Country_Dropdown_New");
        var selected_index = getCountryIndex(selected_country);
        setCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
        setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);

    }
    else {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var geocoder = new google.maps.Geocoder;
                var point = new google.maps.LatLng(
                    position.coords.latitude, position.coords.longitude);
                geocoder.geocode({ 'latLng': point }, function (locations, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        var data1 = locations[0].formatted_address;
                        var nameArr = data1.split(',');
                        var selected_country = nameArr[nameArr.length - 1].trim();

                        localStorage.setItem("Country_Dropdown_New", selected_country);

                        // document.getElementById('main-country-dropdown').value = selected_country;
                        // setMainCountryDropdown('main-country-dropdown');
                        document.getElementById('pricing-dropdown-options').value = selected_country;
                        setMainCountryDropdown('pricing-dropdown-options');
                        // var x = document.getElementById('pricing-dropdown-options').value;
                        var selected_index = getCountryIndex(selected_country);
                        setCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
                        setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
                    }
                });
            }, function block() {
                var selected_country = "USA";
                var selected_index = getCountryIndex(selected_country);

                document.getElementById('main-country-dropdown').value = selected_country;
                setMainCountryDropdown('main-country-dropdown');
                setCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
                setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
                // if (selected_country != "UK") {
                localStorage.setItem("Country_Dropdown_New", selected_country);
                // }
            }, ({ enableHighAccuracy: false }));
        }
        if (!navigator.geolocation) {
            var selected_country = "USA";
            var selected_index = getCountryIndex(selected_country);
            document.getElementById('main-country-dropdown').value = selected_country;
            setMainCountryDropdown('main-country-dropdown');
            setCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
            setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
            localStorage.setItem("Country_Dropdown_New", selected_country);
        }
    }
}



// added by sagar for location chnage
async function getlocationAndSetMainCountryDroupDown() {
    if (Boolean(localStorage.getItem("Country_Dropdown_New"))) {
        var selected_country = localStorage.getItem("Country_Dropdown_New");
        var selected_index = getCountryIndex(selected_country);
        setMainCountryDropdown('main-country-dropdown');
        setMainCountryDropdown('main-country-dropdown-1');
        document.getElementById('main-country-dropdown').value = selected_index;
        document.getElementById('main-country-dropdown-1').value = selected_index;
        setCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
        setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
        setLanguage();
    }
    else {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var geocoder = new google.maps.Geocoder;
                var point = new google.maps.LatLng(
                    position.coords.latitude, position.coords.longitude);
                geocoder.geocode({ 'latLng': point }, function (locations, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        var data1 = locations[0].formatted_address;
                        var nameArr = data1.split(',');
                        var selected_country = nameArr[nameArr.length - 1].trim();
                        // if (selected_country != "UK") {
                        localStorage.setItem("Country_Dropdown_New", selected_country);
                        // }
                        var selected_index = getCountryIndex(selected_country);
                        setMainCountryDropdown('main-country-dropdown');
                        setMainCountryDropdown('main-country-dropdown-1');
                        setCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
                        setLanguage();
                        setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
                        document.getElementById('main-country-dropdown').value = selected_index;
                        document.getElementById('main-country-dropdown-1').value = selected_index;
                    }
                });
            }, function block() {
                console.log(1)
                var selected_country = "USA";
                var selected_index = getCountryIndex(selected_country);
                setMainCountryDropdown('main-country-dropdown');
                setMainCountryDropdown('main-country-dropdown-1');
                document.getElementById('main-country-dropdown').value = selected_country;
                document.getElementById('main-country-dropdown-1').value = selected_country;
                setCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
                setLanguage();
                setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
                localStorage.setItem("Country_Dropdown_New", selected_country);
            }, ({ enableHighAccuracy: false }));
        }
        if (!navigator.geolocation) {
            console.log(2)
            var selected_country = "USA";
            var selected_index = getCountryIndex(selected_country);
            setMainCountryDropdown('main-country-dropdown');
            setMainCountryDropdown('main-country-dropdown-1');
            document.getElementById('main-country-dropdown').value = selected_country;
            document.getElementById('main-country-dropdown-1').value = selected_country;
            setCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
            setLanguage();
            setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
            localStorage.setItem("Country_Dropdown_New", selected_country);

        }
    }



}


async function diet_location_pricing() {
    if (Boolean(localStorage.getItem("Country_Dropdown_New"))) {
        var selected_country = localStorage.getItem("Country_Dropdown_New");
        var selected_index = getCountryIndex(selected_country);
        // document.getElementById('pricing-dropdown-options').value = selected_country;
        if (selected_index == 0) {
            setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index]);
        }
        else {
            setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
        }
    }
    else {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var geocoder = new google.maps.Geocoder;
                var point = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                geocoder.geocode({ 'latLng': point }, function (locations, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        var data1 = locations[0].formatted_address;
                        var nameArr = data1.split(',');
                        var selected_country = nameArr[nameArr.length - 1].trim();
                        // if (selected_country != "UK") {
                        localStorage.setItem("Country_Dropdown_New", selected_country);
                        // }
                        // document.getElementById('pricing-dropdown-options').value = selected_country;
                        // var x = document.getElementById('pricing-dropdown-options').value;
                        var selected_index = getCountryIndex(selected_country);
                        if (selected_index == 0) {
                            setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index]);
                        }
                        else {
                            setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
                        }
                    }
                });
            }, function block(error) {
                var selected_country = "USA";
                localStorage.setItem("Country_Dropdown_New", selected_country);
                var selected_index = getCountryIndex(selected_country);
                setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
            }, ({ enableHighAccuracy: false }));

        }
        if (!navigator.geolocation) {
            var selected_country = "USA";
            localStorage.setItem("Country_Dropdown_New", selected_country);
            var selected_index = getCountryIndex(selected_country);
            setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_index - 1]);
        }


    }
}

// function dietPricingUpdate(){
//     var selected_country = localStorage.getItem("Country_Dropdown_New");
//     var basicOldUs = document.getElementById("basicOldUs")
//     var basicNewUs = document.getElementById("basicNewUs")
//     var basicPlusOldUs = document.getElementById("basicPlusOldUs")
//     var basicPlusNewUs = document.getElementById("basicPlusNewUs")
//     var proOldUs = document.getElementById("proOldUs")
//     var proNewUs = document.getElementById("proNewUs")
//     if(selected_country === "USA"){
//         if(basicOldUs) basicOldUs.innerHTML = '$240';
//         if(basicNewUs) basicNewUs.innerHTML = '$199';
//         if(basicPlusOldUs) basicPlusOldUs.innerHTML = '$332';
//         if(basicPlusNewUs) basicPlusNewUs.innerHTML = '$249';
//         if(proOldUs) proOldUs.innerHTML = '$388';
//         if(proNewUs) proNewUs.innerHTML = '$299';
//     }
//     else{
//         if(basicOldUs) basicOldUs.innerHTML = '₹3000';
//         if(basicNewUs) basicNewUs.innerHTML = '₹2499';
//         if(basicPlusOldUs) basicPlusOldUs.innerHTML = '₹6000';
//         if(basicPlusNewUs) basicPlusNewUs.innerHTML = '₹4499';
//         if(proOldUs) proOldUs.innerHTML = '₹9000';
//         if(proNewUs) proNewUs.innerHTML = '₹6999';
//     }
// }

function myFunction1() {
    // Get the text field
    //var copyText = document.getElementById("cpy");

    // Select the text field
    //copyText.select();
    //copyText.setSelectionRange(0, 99999); // For mobile devices
    // Copy the text inside the text field
    //navigator.clipboard.writeText($scope.code);
    var copyTextareaBtn = document.querySelector('.js-textareacopybtn');

    copyTextareaBtn.addEventListener('click', function (event) {
        var copyTextarea = document.querySelector('.js-copytextarea');
        copyTextarea.focus();
        copyTextarea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';

        } catch (err) {

        }
    });
}

function changecountry() {
    var selected_country = document.getElementById('pricing-dropdown-options').value;
    // var selected_index = getCountryIndex(selected_country);
    // if (selected_country != "UK") {
    localStorage.setItem("Country_Dropdown_New", MAIN_COUNTRY_DROPDOWN_LIST[selected_country].label);
    // }
    setCountryData(PRICING_DATA_GLOBAL_LIST[selected_country - 1]);
    setDietCountryData(PRICING_DATA_GLOBAL_LIST[selected_country - 1]);
    setMainCountryDropdown('pricing-dropdown-options');
    getDietValues();
    // checkpackagescountry();
    setPriceCountry();
}

var coll = document.getElementsByClassName("faq-collapsible");
// var i;


for (let i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var content = this.nextElementSibling;
        if (content.style.maxHeight) {
            content.style.maxHeight = null;
        } else {
            content.style.maxHeight = content.scrollHeight + "px";
        }
    });
}

$(document).ready(function () {
    $('#why-egd-watch-button').click(function () {
        var $this = $(this);
        $('.why-egd-video').slideToggle("slow");
    });
});

/////

document.addEventListener('DOMContentLoaded', function () {

    var overlay = document.getElementById("overlay");

    var countryDropdown = document.getElementById("main-country-dropdown");
    var languageDropdown = document.getElementById("language-dropdown");
    var submitBtn = document.getElementById("submit-btn");
    var arrow_home = document.getElementById("openModalIconArrow")

    var arrow_mobile = document.getElementById("openModalIconArrow-mobile")
    var countryDropdown_mobile = document.getElementById("main-country-dropdown-1");
    var languageDropdown_mobile = document.getElementById("language-dropdown-mobile");
    var submitBtn_mobile = document.getElementById("submit-btn-mobile");
    var modal_mobile = document.getElementById("myModal-mobile")



    var allLanguages = [
        { code: 'en', name: 'English' },
        { code: 'fr', name: 'French' },
        { code: 'es', name: 'Spanish' },
        { code: 'pt', name: 'Portuguese' },
        { code: 'de', name: 'German' },
        { code: 'hi', name: 'Hindi' },
        { code: 'ar', name: 'Arabic'},
        // { code: 'ru', name: 'Russian'},
        { code: 'mr', name: 'Marathi' },
        { code: 'gu', name: 'Gujarati' },
        { code: 'te', name: 'Telugu' },
        { code: 'ta', name: 'Tamil' },
        { code: 'bn', name: 'Bengali' },
        { code: 'ur', name: 'Urdu' },
        { code: 'pa', name: 'Punjabi' },
        { code: 'kn', name: 'Kannada' },
        //{ code: 'ml', name: 'Malayalam' },
        { code: 'or', name: 'Oriya' },
        { code: 'ne', name: 'Nepali' }
    ];

    allLanguages.sort((a, b) => a.name.localeCompare(b.name));

    var limitedLanguages = [
        { code: 'en', name: 'English' },
        { code: 'ar', name: 'Arabic'},
        { code: 'fr', name: 'French' },
        { code: 'ar', name: 'Arabic'},
        // { code: 'ru', name: 'Russian'},
        { code: 'es', name: 'Spanish' },
        { code: 'pt', name: 'Portuguese' },
        { code: 'de', name: 'German' },
        { code: 'hi', name: 'Hindi' }
    ];

    limitedLanguages.sort((a, b) => a.name.localeCompare(b.name));

    if (arrow_home !== null) {
        arrow_home.onclick = function () {
            overlay.style.display = "flex";
            overlay.style.animation = "slide-down 0.0s forwards";
            populateLanguages();
        }
    }

    if (arrow_mobile !== null) {
        arrow_mobile.onclick = function () {
            modal_mobile.style.display = "block"
            modal_mobile.style.animation = "slide-down 0.0s forwards";
            populateLanguages_mobile();
        }
    }


    if (submitBtn !== null) {
        submitBtn.onclick = function () {
            overlay.style.display = 'none';
            var selectedLanguage = languageDropdown.value.toLowerCase();

            function attemptToFindGoogleTranslateElement(retryCount) {
                var googleTranslateElement = document.querySelector('.goog-te-combo');
                if (googleTranslateElement) {
                    googleTranslateElement.value = selectedLanguage;
                    googleTranslateElement.dispatchEvent(new Event('change'));
                    //console.log('Language changed to:', selectedLanguage);
                    localStorage.setItem('selectedLanguage', selectedLanguage);
                    setLanguage();
                    updateUI();
                } else {
                    if (retryCount > 0) {
                        console.warn(`Google Translate combo box not found. Retrying... (${retryCount} retries left)`);
                        setTimeout(() => attemptToFindGoogleTranslateElement(retryCount - 1), 1000); // Retry after 1 second
                    } else {
                        console.error('Google Translate combo box not found after multiple attempts.');
                    }
                }
            }

            attemptToFindGoogleTranslateElement(5);
            setLanguageCookie();

        }
    }


    if (submitBtn_mobile !== null) {
        submitBtn_mobile.onclick = function () {
            modal_mobile.style.display = "none";
            var selectedLanguage_Mobile = languageDropdown_mobile.value.toLowerCase();

            function attemptToFindGoogleTranslateElement(retryCount) {
                var googleTranslateElement = document.querySelector('.goog-te-combo');
                if (googleTranslateElement) {
                    googleTranslateElement.value = selectedLanguage_Mobile;
                    googleTranslateElement.dispatchEvent(new Event('change'));
                    //console.log('Language changed to:', selectedLanguage_Mobile);
                    localStorage.setItem('selectedLanguage', selectedLanguage_Mobile);
                    onMainCountryDropdownChange1('main-country-dropdown-1');
                    setLanguageMobile();
                    updateUI();
                } else {
                    if (retryCount > 0) {
                        console.warn(`Google Translate combo box not found. Retrying... (${retryCount} retries left)`);
                        setTimeout(() => attemptToFindGoogleTranslateElement(retryCount - 1), 1000);
                    } else {
                        console.error('Google Translate combo box not found after multiple attempts.');
                    }
                }
            }

            attemptToFindGoogleTranslateElement(5);
            setLanguageCookie();
        };
    }

    window.onclick = function (event) {
        if (event.target === overlay) {
            overlay.style.display = "none";
        }
        if (event.target === modal_mobile) {
            modal_mobile.style.display = "none"
        }
    }

    if (countryDropdown !== null) {
        countryDropdown.addEventListener('change', function () {
            populateLanguages();
        });
    }

    if (countryDropdown_mobile !== null) {
        countryDropdown_mobile.addEventListener('change', function () {
            populateLanguages_mobile();
        });
    }

    function populateLanguages() {
        var selectedCountry = countryDropdown.value;
        languageDropdown.innerHTML = '';

        var languagesToShow = (selectedCountry == 2) ? allLanguages : limitedLanguages;
        languagesToShow.forEach(function (language) {
            var option = document.createElement('option');
            option.value = language.code;
            option.textContent = language.name;
            var languageCode = localStorage.getItem('selectedLanguage');
            if (language.code === languageCode) {
                option.selected = true;
            }
            languageDropdown.appendChild(option);
        });
    }

    function populateLanguages_mobile() {
        var selectedCountry = countryDropdown_mobile.value;
        languageDropdown_mobile.innerHTML = '';

        var languagesToShow = (selectedCountry == 2) ? allLanguages : limitedLanguages;
        languagesToShow.forEach(function (language) {
            var option = document.createElement('option');
            option.value = language.code;
            option.textContent = language.name;
            var languageCode = localStorage.getItem('selectedLanguage');
            if (language.code === languageCode) {
                option.selected = true;
            }
            languageDropdown_mobile.appendChild(option);
        });
    }

    populateLanguages();
    populateLanguages_mobile();

    var closeModal = document.getElementById("closeModal");
    var closeModal_Mobile = document.getElementById("closeModal-mobile");

    if (closeModal !== null) {
        closeModal.onclick = function () {
            overlay.style.display = "none";
            modal_mobile.style.display = "none"
        }
    }

    if (closeModal_Mobile !== null) {
        closeModal_Mobile.onclick = function () {
            modal_mobile.style.display = "none"
        }
    }

    window.onclick = function (event) {
        if (event.target === overlay) {
            overlay.style.display = "none";
        }
    }

});

function setLanguageCookie() {
    var selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
    const expires = new Date('9999-12-31T23:59:59Z').toUTCString();
    const domain = 'eglobaldoctors.com';
    try {
        document.cookie = `selectedLanguageClient=${selectedLanguage}; expires=${expires}; domain=${domain}; path=/; Secure;`;
        console.log(document.cookie);
    } catch (error) {
        console.error('Invalid URL:', error);
    }
}

function updateUI() {
    const lang = localStorage.getItem('selectedLanguage');
    const loginBtn = document.getElementById('loginBtn');
    const registerBtn = document.getElementById('registerBtn');
    const navLogo = document.getElementById('navLogo');
    const navbarMargin = document.getElementById('navbarMargin');
    const subNavbarFont = document.getElementById('subNavbarFont');
    const navbarSupportedContent = document.getElementById('navbarSupportedContent');

    const languagesSubNav = ["fr", "de", "kn", "or", "pt", "es", "te", "ta", "ml"];
    if (subNavbarFont && languagesSubNav.includes(lang)) {
        subNavbarFont.style.fontSize = "10px";
    } else if (subNavbarFont) {
        subNavbarFont.style.fontSize = "";
    }

    if (loginBtn && registerBtn) {
        if (lang !== 'en') {
            loginBtn.classList.remove('mx-3');
            loginBtn.classList.add('mx-1');
            registerBtn.classList.remove('mx-3');
            registerBtn.classList.add('mx-1');
        } else {
            loginBtn.classList.remove('mx-1');
            loginBtn.classList.add('mx-3');
            registerBtn.classList.remove('mx-1');
            registerBtn.classList.add('mx-3');
        }
    }

    if (navLogo) {
        if (lang !== 'en') {
            navLogo.style.height = '50px';
            navLogo.style.width = '180px';
        } else {
            navLogo.style.height = '';
            navLogo.style.width = '';
        }
    }

    if (navbarMargin) {
        if (lang !== 'en') {
            navbarMargin.classList.add('mt-3');
        } else {
            navbarMargin.classList.remove('mt-3');
        }
    }

    if (navbarSupportedContent && ['kn', 'es', 'te', 'ta', 'ml'].includes(lang)) {
        function adjustNavLinks() {
            if (window.innerWidth <= 1350) {
                const links = navbarSupportedContent.querySelectorAll('a.nav-link');
                links.forEach(link => {
                    link.classList.remove('heading5');
                    link.style.fontSize = "13px";
                });
            } else {
                const links = navbarSupportedContent.querySelectorAll('a.nav-link');
                links.forEach(link => {
                    link.classList.add('heading5');
                    link.style.fontSize = "";
                });
            }
        }

        adjustNavLinks();
        window.addEventListener('resize', adjustNavLinks);
    }
}

updateUI()

function setLanguage() {
    if (!localStorage.getItem('selectedLanguage')) {
        localStorage.setItem('selectedLanguage', 'en')
    }
    var languageChoosen = localStorage.getItem('selectedLanguage');
    var storedCountry = localStorage.getItem('Country_Dropdown_New');
    var selectedcountry = document.getElementById('selectedcountry');
    var selectedcountrymobile = document.getElementById('selectedcountry-mobile');
    if (storedCountry) {
        var upperLanguage = languageChoosen.toUpperCase();
        selectedcountry.textContent = storedCountry + " (" + upperLanguage + ")";
        selectedcountrymobile.textContent = storedCountry + " (" + upperLanguage + ")";
    } else {
        selectedcountry.textContent = 'No Country Selected';
    }
}

function updateLanguage() {
    var langcode = localStorage.getItem('selectedLanguage') || 'en';
    var googleTranslateElement = document.querySelector('.goog-te-combo');
    if (googleTranslateElement) {
        googleTranslateElement.value = langcode;
        googleTranslateElement.dispatchEvent(new Event('change'));
        //console.log('Language changed to:', langcode);
        localStorage.setItem('selectedLanguage', langcode);
    }
}



// function updateLanguage_Mobile() {
//     var langcode = localStorage.getItem('selectedLanguageMobile') || 'en';
//     var googleTranslateElement = document.querySelector('.goog-te-combo');
//     if (googleTranslateElement) {
//         googleTranslateElement.value = langcode;
//         googleTranslateElement.dispatchEvent(new Event('change'));
//         //console.log('Language changed to:', langcode);
//         localStorage.setItem('selectedLanguage', langcode);
//     }
// }

// updateLanguage_Mobile()


function setLanguageMobile() {
    if (!localStorage.getItem('selectedLanguage')) {
        localStorage.setItem('selectedLanguage', 'en')
    }
    var languageChoosen = localStorage.getItem('selectedLanguage') || 'en';
    var storedCountry = localStorage.getItem('Country_Dropdown_New');
    //console.log(storedCountry)
    var selectedcountry = document.getElementById('selectedcountry');
    var selectedcountrymobile = document.getElementById('selectedcountry-mobile');
    if (storedCountry) {
        var upperLanguage = languageChoosen.toUpperCase();
        //console.log(upperLanguage)
        selectedcountry.textContent = storedCountry + " (" + upperLanguage + ")";
        selectedcountrymobile.textContent = storedCountry + " (" + upperLanguage + ")";
    } else {
        selectedcountry.textContent = 'No Country Selected';
    }
}

////

function getConsultationAndCommonHealthIssueLandingData() {
    $.ajax({
        async: true,
        type: "GET",
        url: URLS[CURRENT_SELECTED_MAIN_COUNTRY_INDEX].API_BASE_URL + 'dashboard/fetch/common/health/issues',
        headers: {
            'platform': 'web',
        },
        contentType: "application/json",
        success: function (response) {

        },
        error: function (jqXHR, textStatus, errorThrown) {

        },
    })
        .done(function (result, textStatus, jqXHR) {

            if (Boolean(result)) {
                if (Boolean(result.success)) {
                    console.log(result)

                }
                else if (!Boolean(result.success)) {
                }
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {


        })
        .always(function (jqXHR, textStatus, errorThrown) {

        });
}


function showModal(targetModalId) {
    const targetModal = document.getElementById(targetModalId);
    if (targetModal) {
        targetModal.style.display = 'block';
    }
}

function closeModal(targetModalId) {
    const targetModal = document.getElementById(targetModalId);
    if (targetModal) {
        targetModal.style.display = 'none';
    }
}

function hideError(elementId) {
    document.getElementById(elementId).innerText = '';
}

// function applyLanguage() {
//     var langcode = localStorage.getItem('selectedLanguage') || 'en';
//     var googleTranslateElement = document.querySelector('.goog-te-combo');
    
//     if (googleTranslateElement) {
//         googleTranslateElement.value = langcode;
//         googleTranslateElement.dispatchEvent(new Event('change'));
//         // Optional: log the language change for debugging
//         console.log('Language changed to:', langcode);
//     } else {
//         console.error('Google Translate element not found.');
//     }
// }

// window.addEventListener('pageshow', (event) => {
//     if (event.persisted) {
//         $("#sidePanel").removeClass("show");

//         // Wait for Google Translate to initialize properly
//         setTimeout(() => {
//             applyLanguage();
//         }, 1000); // Delay to ensure the element is ready
//     }
// });

// // Apply language on page load as well
// document.addEventListener('DOMContentLoaded', () => {
//     applyLanguage();
// });


async function url_based_function_caller() {
    var current_url = window.location.pathname.split("/").map(url => { return url.toLowerCase() });

    setGlobalPricingDataValues(); //async is false 
    if (Boolean(current_url)) {
        if (Boolean(current_url[1]) == false || current_url[1] === "index.html" || current_url[1] === "index.") {
            // include_contact_us();
            // include_strength_in_numbers_html();
            //  
            setLanguage();
            setLanguageMobile();
            getlocationAndSetMainCountryDroupDown();
            getExploreMore();
            checkcountry();
            getYoutubeLinks();
            getDoctorYoutubeLinks();
            getFeaturedIn();
            getFeaturedSpecialties();
            getFeaturedDoctors();
            getOurPartners();
            getFeaturedNews();
            getFeaturedTestimonials();
            // main_countDown_timer();
            getContainerImages();
            // toggledivmob();

            //  onLinkChange();
            onLinkChange1();
            setLanguageCookie();
            getContainerImages('containers-data-div');

        }
        else if (current_url[1] === "news.html" || current_url[1] === "news") {
            getViewAllNews();
        }

        else if (current_url[1] === "cancer-care.html" || current_url[1] === "cancer-care") {
            getOncologyDoctors();
            getPhonecodeOptionValues('oncology_phone_code');
        }
        else if (current_url[1] === "business-page.html" || current_url[1] === "business-page") {
            getPhonecodeOptionValues('bpage_phone_code');
            getPhonecodeOptionValues('oncology_phone_code');
            getOurPartners();
        }
        else if (current_url[1] === "licensing-marketing-page.html" || current_url[1] === "licensing-marketing-page") {
            getPhonecodeOptionValues('licencing_phone_code');
        }
        else if (current_url[1] === "leadership.html" || current_url[1] === "leadership") {
            getLeadershipData();
            getAdvisoryData();

        }

        else if (current_url[1] === "privacy-policy.html" || current_url[1] === "privacy-policy") {
            getPrivacyPolicyData();
        }
        else if (current_url[1] === "terms-of-use.html" || current_url[1] === "terms-of-use") {
            getTermsOfUseData();
        }
        else if (current_url[1] === "diet-programs.html" || current_url[1] === "diet-programs") {
            getDietData();
            setCountryDropdownDataPricing();
            getDietValues();
            diet_location_pricing();
            getFeaturedNutritionists();

        }
        else if (current_url[1] === "terms-and-conditions.html" || current_url[1] === "terms-and-conditions") {
            getTermsAndConditionsData();
        }
        else if (current_url[1] === "pricing-telehealth-consultation.html" || current_url[1].toLowerCase() === "pricing-telehealth-consultation") {
            setCountryDropdownDataPricing();
            location_pricing();
            getPackageData();
            // include_strength_in_numbers_html();
        }
        else if (current_url[1] === "primary-consultation-telehealth-consultation.html" || current_url[1] === "primary-consultation-telehealth-consultation") {
            setCountryDropdownDataPricing();
            location_pricing();
            getPackageData();
            // include_strength_in_numbers_html();
        }
        else if (current_url[1] === "expert-second-medical-opinion.html" || current_url[1] === "expert-second-medical-opinion") {
            setCountryDropdownDataPricing();
            location_pricing();
            getPackageData();
            // include_strength_in_numbers_html();
        }
        else if (current_url[1] === "multispecialty-telehealth-consultation.html" || current_url[1] === "multispecialty-telehealth-consultation") {
            setCountryDropdownDataPricing();
            location_pricing();
            getPackageData();
            // include_strength_in_numbers_html();
        }
        else if (current_url[1] === "view-profile.html" || current_url[1] === "view-profile") {
            viewProfile();
        }
        else if (current_url[1] === "affordable-healthcare-packages.html" || current_url[1] === "affordable-healthcare-packages") {

            setCountryDropdownDataPricing();
            location_pricing();
            checkpackagescountry();

        }
        else if (current_url[1] === "doctors.html" || current_url[1] === "doctors") {
            getViewAllDoctors();
        }

        // else if (current_url[1] === "pharmacy.html" || current_url[1] === "pharmacy") {
        //     getEmailForNotification()
        // }
        // else if (current_url[1] === "diagnostics.html" || current_url[1] === "diagnostics") {
        //     getEmailForNotification()
        // }
        // else if (current_url[1] === "homecare.html" || current_url[1] === "homecare") {
        //     getEmailForNotification()
        // }
        else if (current_url[1] === "view-specialties.html" || current_url[1] === "view-specialties") {
            getViewAllSpecialties();
        }
        else if (current_url[1] === "healthvideos.html" || current_url[1] === "healthvideos") {
            getHealthcareVideos();
        }
        else if (current_url[1] === "equipmentsupport.html" || current_url[1] === "equipmentsupport") {
            setEquipmentSupportLinks();
            getEquipmentSupportTimingsandZoomLink();
        }
        else if (current_url[1] === "technicalsupportrequester.html" || current_url[1] === "technicalsupportrequester") {
            setTechnicalSupportRequesterLinks();
            getTechnicalSupportRequesterZoomLink();
        }
        else if (current_url[1] === "technicalsupport.html" || current_url[1] === "technicalsupport") {
            setTechnicalSupportLinks();
            // getTechnicalSupportZoomLink();
        }
        else if (current_url[1] === "faq-patient.html" || current_url[1] === "faq-patient") {
            // include_contact_us();
        }
        else if (current_url[1] === "faq-doctor.html" || current_url[1] === "faq-doctor") {
            // include_contact_us();
        }
        else if (current_url[1] === "view-doctors.html" || current_url[1] === "view-doctors") {
            setCountryDropdownDataViewDoctors();
            onChangeCountryViewDoctors();
        }
        else if (current_url[1] === "aboutus.html" || current_url[1] === "aboutus") {
            // include_strength_in_numbers_html();
        }
        else if (current_url[1] === "ayurvedic-care.html" || current_url[1] === "ayurvedic-care") {
            getAyurvedicDoctors();
        }
        else if (current_url[1] === "book-appointment.html" || current_url[1] === "book-appointment") {
            getConsultationAndCommonHealthIssueLandingData();
            getContainerImages('book-appointment-issues');
        }

        // browserbackbutton();
    }
}



url_based_function_caller();



window.openWebsiteLinks = openWebsiteLinks;
window.watchVideo = watchVideo;
window.open_home_news = open_home_news;
window.openProfile = openProfile;
window.setYoutubeLink = setYoutubeLink;
window.open_link = open_link;
window.formSubmit = formSubmit;
window.Business_formSubmit = Business_formSubmit;
window.BusinessformSubmit = BusinessformSubmit;
window.licencingFormSubmit = licencingFormSubmit;
window.changecountry = changecountry;
window.updateLanguage = updateLanguage;
//window.updateLanguage_Mobile = updateLanguage_Mobile
window.setLanguageCookie = setLanguageCookie
window.showModal = showModal;
window.closeModal = closeModal;
window.onMainCountryDropdownChange = onMainCountryDropdownChange;
// added by sagar
window.onMainCountryDropdownChange1 = onMainCountryDropdownChange1;
window.viewAllDoctorSearch = viewAllDoctorSearch;
window.viewAllSpecialtySearch = viewAllSpecialtySearch;
window.onChangeCountryViewDoctors = onChangeCountryViewDoctors;
window.onChangeStateViewDoctors = onChangeStateViewDoctors;
window.show_less_doctors = show_less_doctors;
window.load_more_doctors = load_more_doctors;
window.show_less_nutritionist = show_less_nutritionist;
window.load_more_nutritionist = load_more_nutritionist;
window.goToTop = goToTop;
window.toggleNav = toggleNav;
window.closeNav = closeNav;
window.goToID = goToID;
window.showmobdiv = showmobdiv;
window.onhashchange = locationHashChanged;
window.OnClickConsultationType = OnClickConsultationType;
window.offercodecopy = offercodecopy;
window.hideError = hideError;
window.onscroll = function () { onScrollEvent() };
